import React, { useEffect, useRef, useState } from "react";
import SidebarNav from "../sidebar";
import { useParams, useHistory } from "react-router-dom";
import {
  getUserById,
  getUserWalletTrx,
  getUserFireblocksWallet,
  getUserWalletByType,
  getOrderCoinDcx,
  getLogsApi,
  getLogActionsApi,
  getUserActivityLogApi,
  getUserActivityLogFilterOptionsApi,
  exportUserActivityLogApi,
  getUserThirdPartyData,
  freezeUserAccount,
  restrictUserWithdrawal,
  deleteUser,
  reactivateUser,
  deactivateUser,
  activateUser,
  approveUserBank,
  rejectUserBank,
  triggerKycRedo,
  sendKycReviewOtp,
  resendKycReviewOtp,
  decideKycReview,
  getKycReviewHistory,
  getWithdrawalReq,
  getInrTransactionCounts,
  blockUserWithReason,
  getUserKycConfig,
  updateUserKycConfig,
  getResolvedKycConfig,
} from "../../../service/api";
import { toast } from "react-toastify";
import {
  FiSlash,
  FiCheckCircle,
  FiPauseCircle,
  FiXOctagon,
  FiRefreshCw,
  FiTrash2,
  FiRotateCcw,
  FiZap,
  FiChevronRight,
  FiUserX,
  FiUserCheck,
  FiCopy,
} from "react-icons/fi";
import moment from "moment";
import { Spin, Table, Tabs, Collapse, Tooltip } from "antd";
import { Button } from "@mui/material";
import DetailLayout from "../commoncomponent/DetailLayout";
import DetailSection, { DetailRow } from "../commoncomponent/DetailSection";
import CryptoWithdrawTab from "./CryptoWithdrawTab";
import WalletAdjustmentTab from "./WalletAdjustmentTab";
import PermissionGate from "../commoncomponent/PermissionGate";
import CustomPagination from "../Pagination/pagination";
import { saveBlobAsFile } from "../FinanceDashboard/shared";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";

// ─── helpers ────────────────────────────────────────────────────────────────

const incomeLabel = (v) =>
  v === "<25"
    ? "Below 25 Lakhs"
    : v === "25-50"
    ? "25-50 Lakhs"
    : v === ">50"
    ? "Above 50 Lakhs"
    : null;

const renderBool = (v) => (v === true ? "Yes" : v === false ? "No" : null);

const fmtDate = (v) => (v ? moment(v).utcOffset("+05:30").format("DD/MM/YYYY hh:mm A") : null);

const copyText = (text) => {
  navigator.clipboard.writeText(text).then(() => toast.success("Copied!", { toastId: 'copy-success' }));
};

const CopyableHash = ({ value, sliceLen = 12 }) => {
  if (!value) return "-";
  return (
    <Tooltip title={value} overlayStyle={{ maxWidth: 420 }}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
        <span style={{ fontFamily: "monospace", fontSize: 11 }}>{value.slice(0, sliceLen)}…</span>
        <FiCopy
          size={12}
          style={{ cursor: "pointer", color: "#888", flexShrink: 0 }}
          onClick={(e) => { e.stopPropagation(); copyText(value); }}
        />
      </span>
    </Tooltip>
  );
};

const classifyFile = (url, label) => {
  const ext = url?.split(".")?.pop()?.toLowerCase();
  if (["jpg", "jpeg", "png", "webp"].includes(ext))
    return { url, type: "image", label };
  if (["mp4", "webm", "ogg"].includes(ext))
    return { url, type: "video", label };
  return { url, type: "doc", label };
};

const parseEddDocs = (docs) => {
  if (!docs || typeof docs !== "object") return [];
  let files = [];
  Object.entries(docs).forEach(([key, value]) => {
    if (!value) return;
    if (Array.isArray(value)) {
      value.forEach((url) => url && files.push(classifyFile(url, key)));
    } else if (typeof value === "string" && value.trim()) {
      files.push(classifyFile(value, key));
    }
  });
  return files;
};

const parseOldEddDocs = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return [];
  let files = [];
  arr.forEach((docObj, index) => {
    if (docObj && typeof docObj === "object") {
      Object.entries(docObj).forEach(([key, value]) => {
        if (!value) return;
        if (Array.isArray(value)) {
          value.forEach((url) => url && files.push(classifyFile(url, `${key}_${index}`)));
        } else if (typeof value === "string" && value.trim()) {
          files.push(classifyFile(value, `${key}_${index}`));
        }
      });
    }
  });
  return files;
};

const DocGrid = ({ files }) => (
  <div style={{ display: "flex", flexWrap: "wrap", gap: 16, padding: "12px 16px" }}>
    {files.map((file, i) => (
      <div key={i} style={{ textAlign: "center" }}>
        <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>{file.label}</div>
        {file.type === "image" ? (
          <img
            src={file.url}
            alt={file.label}
            draggable="false"
            onContextMenu={(e) => e.preventDefault()}
            style={{ width: 200, height: "auto", objectFit: "contain", borderRadius: 4, border: "1px solid #ccc" }}
          />
        ) : file.type === "video" ? (
          <video controls src={file.url} style={{ width: 200, height: "auto", borderRadius: 4 }} />
        ) : file.label === "date" ? (
          <p>{moment(file.url).format("DD/MM/YYYY HH:mm")}</p>
        ) : (
          <a href={file.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
            View Document
          </a>
        )}
      </div>
    ))}
  </div>
);

// ─── stat card ──────────────────────────────────────────────────────────────

const StatCard = ({ label, value, loading }) => (
  <div
    style={{
      flex: "1 1 160px",
      background: "#f8f9fa",
      border: "1px solid #e0e0e0",
      borderRadius: 8,
      padding: "16px 20px",
      textAlign: "center",
    }}
  >
    <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>{label}</div>
    {loading ? (
      <Spin size="small" />
    ) : (
      <div style={{ fontSize: 22, fontWeight: 700 }}>{value ?? "—"}</div>
    )}
  </div>
);

// ─── status color helper for logs ──────────────────────────────────────────

const statusColor = (code) => {
  if (!code) return undefined;
  if (code >= 500) return "#d32f2f";
  if (code >= 400) return "#e65100";
  if (code >= 200) return "#2e7d32";
  return undefined;
};

// ─── wallet activity log tab ────────────────────────────────────────────────
//
// A genuine top-level component (not an inline closure re-created on every
// UserProfileView render, the way the other tabs below are defined) — that
// was the root cause of the search/token inputs losing focus after every
// keystroke: each parent re-render produced a NEW `WalletActivityLogTab`
// function reference, so React treated it as a different component type and
// remounted the whole subtree (including the <input> DOM node) on every
// character typed. Being defined once, here, with its own state and taking
// `userId`/`active` as props, keeps its identity stable across parent
// re-renders and fixes that.

const TRADE_ACTIVITY_TYPES = ["BUY_TRADE", "SELL_TRADE", "TRADE_REVERSAL"];
const ACTIVITY_SEARCH_DEBOUNCE_MS = 400;

const UserActivityLogTab = ({ userId, active }) => {
  const hasLoadedRef = useRef(false);

  const [activityList, setActivityList] = useState([]);
  const [activityTotal, setActivityTotal] = useState(0);
  const [activityPage, setActivityPage] = useState(1);
  const [activityPageSize, setActivityPageSize] = useState(25);
  const [activityType, setActivityType] = useState("");
  const [activityWalletType, setActivityWalletType] = useState("");
  const [activityToken, setActivityToken] = useState("");
  const [activityExchange, setActivityExchange] = useState("");
  const [activityStatus, setActivityStatus] = useState("");
  const [activitySearch, setActivitySearch] = useState("");
  const [activityStart, setActivityStart] = useState(null);
  const [activityEnd, setActivityEnd] = useState(null);
  const [activityLoading, setActivityLoading] = useState(false);
  const [activityExporting, setActivityExporting] = useState("");
  const [activityFilterOptions, setActivityFilterOptions] = useState({
    activityTypes: [], exchanges: [], walletTypes: [], statuses: [], tokens: [],
  });

  // Free-text draft state updates on every keystroke so typing feels
  // instant; the committed activitySearch/activityToken values (which
  // trigger the actual fetch) update after a short pause, so the API isn't
  // hit on every single character.
  const [searchDraft, setSearchDraft] = useState("");
  const [tokenDraft, setTokenDraft] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setActivitySearch(searchDraft), ACTIVITY_SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [searchDraft]);

  useEffect(() => {
    const t = setTimeout(() => setActivityToken(tokenDraft), ACTIVITY_SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [tokenDraft]);

  // Exchange only means anything for trade rows — hide it (and stop sending
  // it to the API) unless the selected activity type is a trade type, or
  // nothing specific is selected (i.e. "all types").
  const showTradeFilters = !activityType || TRADE_ACTIVITY_TYPES.includes(activityType);

  const buildActivityLogParams = () => {
    const params = { userId };
    if (activityType)       params.activityType = activityType;
    if (activityWalletType) params.walletType   = activityWalletType;
    if (activityToken)      params.token        = activityToken;
    if (activityStatus)     params.status       = activityStatus;
    if (activitySearch)     params.search       = activitySearch;
    if (activityStart)      params.startDate    = activityStart;
    if (activityEnd)        params.endDate      = activityEnd;
    if (showTradeFilters && activityExchange) params.exchange = activityExchange;
    return params;
  };

  const fetchActivityLog = (page = activityPage) => {
    if (!userId) return;
    setActivityLoading(true);
    const params = { ...buildActivityLogParams(), page, sizePerPage: activityPageSize, pagination: true };
    getUserActivityLogApi(params).then((res) => {
      // getUserActivityLogApi resolves with the raw response body already —
      // backend's sendPaginatedPlain puts the row array directly at `.data`
      // and pagination info at `.meta` (no extra nesting to unwrap here).
      setActivityList(res?.data ?? []);
      setActivityTotal(res?.meta?.total ?? 0);
      setActivityLoading(false);
    }).catch(() => setActivityLoading(false));
  };

  // Load once, the first time this tab is actually opened.
  useEffect(() => {
    if (!active || hasLoadedRef.current) return;
    hasLoadedRef.current = true;
    getUserActivityLogFilterOptionsApi().then((res) => {
      const d = res?.data ?? res;
      setActivityFilterOptions(d ?? { activityTypes: [], exchanges: [], walletTypes: [], statuses: [], tokens: [] });
    });
    fetchActivityLog(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  useEffect(() => {
    if (hasLoadedRef.current) fetchActivityLog(activityPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityPage, activityPageSize, activityType, activityWalletType, activityToken, activityExchange, activityStatus, activitySearch, activityStart, activityEnd]);

  useEffect(() => {
    if (hasLoadedRef.current) setActivityPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityPageSize, activityType, activityWalletType, activityToken, activityExchange, activityStatus, activitySearch, activityStart, activityEnd]);

  const handleExportActivityLog = (format) => {
    if (!userId || activityExporting) return;
    setActivityExporting(format);
    exportUserActivityLogApi({ ...buildActivityLogParams(), format })
      .then((res) => saveBlobAsFile(res, `user-activity-log-${userId}.${format === "xlsx" ? "xlsx" : "csv"}`))
      .catch(() => toast.error("Failed to export activity log", { toastId: "activity-log-export-error" }))
      .finally(() => setActivityExporting(""));
  };

  // Trim to a sane number of decimals for crypto-sized amounts while keeping
  // whole INR-style numbers readable.
  const fmtActivityAmount = (n) => {
    if (n == null) return "-";
    const num = Number(n);
    if (!Number.isFinite(num)) return "-";
    return num % 1 === 0 ? num.toLocaleString() : parseFloat(num.toFixed(8)).toString();
  };

  const activityStatusBadgeClass = (s) => {
    if (s === "APPROVED" || s === "COMPLETED" || s === "FILLED") return "bg-success";
    if (s === "REJECTED" || s === "CANCELLED" || s === "REVERSED") return "bg-danger";
    if (s === "PENDING" || s === "OPEN" || s === "PARTIALLY_FILLED" || s === "LOCKED") return "bg-warning";
    return "bg-secondary";
  };

  const activityLabelFor = (row) =>
    activityFilterOptions.activityTypes.find((t) => t.value === row?.activityType)?.label ?? row?.activityType ?? "-";

  const activityPaginationKey = `activity-${activityPageSize}-${activityType}-${activityWalletType}-${activityToken}-${activityExchange}-${activityStatus}-${activitySearch}-${activityStart}-${activityEnd}`;

  const hasActiveFilters = !!(activityType || activityWalletType || activityToken || activityExchange || activityStatus || activitySearch || activityStart || activityEnd);

  return (
    <div style={{ padding: "16px 0" }}>
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
        <select
          value={activityType}
          onChange={(e) => {
            const next = e.target.value;
            setActivityType(next);
            // Clear the now-irrelevant exchange filter when switching away from a trade type.
            if (next && !TRADE_ACTIVITY_TYPES.includes(next)) setActivityExchange("");
          }}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, minWidth: 190 }}
        >
          <option value="">All Activity Types</option>
          {activityFilterOptions.activityTypes
            .filter((t) => t.value !== 'CRYPTO_DEPOSIT' && t.value !== 'CRYPTO_WITHDRAWAL')
            .map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
        </select>

        <select
          value={activityWalletType}
          onChange={(e) => setActivityWalletType(e.target.value)}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13 }}
        >
          <option value="">All Wallets</option>
          {(activityFilterOptions.walletTypes.length ? activityFilterOptions.walletTypes : ["SPOT", "FUNDING"]).map((w) => (
            <option key={w} value={w}>{w}</option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Token (e.g. BTC, INR)"
          value={tokenDraft}
          onChange={(e) => setTokenDraft(e.target.value)}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, minWidth: 140 }}
          list="activity-token-options"
        />
        <datalist id="activity-token-options">
          {activityFilterOptions.tokens.map((t) => <option key={t} value={t} />)}
        </datalist>

        {showTradeFilters && (
          <select
            value={activityExchange}
            onChange={(e) => setActivityExchange(e.target.value)}
            style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13 }}
          >
            <option value="">All Exchanges</option>
            {(activityFilterOptions.exchanges.length ? activityFilterOptions.exchanges : ["coindcx", "kucoin"]).map((ex) => (
              <option key={ex} value={ex}>{ex}</option>
            ))}
          </select>
        )}

        <select
          value={activityStatus}
          onChange={(e) => setActivityStatus(e.target.value)}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13 }}
        >
          <option value="">All Statuses</option>
          {activityFilterOptions.statuses.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        <input
          type="text"
          placeholder={showTradeFilters ? "Search order/ref/UTR…" : "Search ref/UTR…"}
          value={searchDraft}
          onChange={(e) => setSearchDraft(e.target.value)}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, minWidth: 180 }}
        />

        <DateRangePicker
          onApply={(_, picker) => {
            setActivityStart(picker.startDate.format("YYYY-MM-DD"));
            setActivityEnd(picker.endDate.format("YYYY-MM-DD"));
          }}
          onCancel={() => { setActivityStart(null); setActivityEnd(null); }}
        >
          <input
            type="text"
            placeholder="Date range"
            value={activityStart && activityEnd ? `${activityStart} → ${activityEnd}` : ""}
            readOnly
            style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, cursor: "pointer", minWidth: 190 }}
          />
        </DateRangePicker>

        <select
          value={activityPageSize}
          onChange={(e) => setActivityPageSize(parseInt(e.target.value, 10))}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13 }}
        >
          {[25, 50, 100].map((n) => <option key={n} value={n}>{n}/page</option>)}
        </select>

        {hasActiveFilters && (
          <button
            type="button"
            className="btn btn-sm bg-light"
            onClick={() => {
              setActivityType(""); setActivityWalletType(""); setActivityToken(""); setTokenDraft("");
              setActivityExchange(""); setActivityStatus(""); setActivitySearch(""); setSearchDraft("");
              setActivityStart(null); setActivityEnd(null);
            }}
          >
            Clear
          </button>
        )}

        <button
          type="button"
          className="btn btn-sm bg-light"
          disabled={activityLoading}
          onClick={() => fetchActivityLog(activityPage)}
          title="Reload activity log with the current filters"
        >
          {activityLoading ? "Refreshing…" : "↻ Refresh"}
        </button>

        <button
          type="button"
          className="btn btn-sm bg-primary-light"
          disabled={!!activityExporting}
          onClick={() => handleExportActivityLog("csv")}
        >
          {activityExporting === "csv" ? "Exporting…" : "Export CSV"}
        </button>
        <button
          type="button"
          className="btn btn-sm bg-primary-light"
          disabled={!!activityExporting}
          onClick={() => handleExportActivityLog("xlsx")}
        >
          {activityExporting === "xlsx" ? "Exporting…" : "Export Excel"}
        </button>

        {activityTotal > 0 && <span style={{ fontSize: 13, color: "#555" }}>{activityTotal} activit{activityTotal !== 1 ? "ies" : "y"}</span>}
      </div>

      {activityLoading ? (
        <div style={{ textAlign: "center", padding: 40 }}><Spin size="large" /></div>
      ) : (
        <Table
          pagination={false}
          size="small"
          scroll={{ x: 1300 }}
          rowKey={(r) => r?.rowKey}
          dataSource={activityList}
          columns={[
            { title: "Date/Time", key: "date", width: 140, render: (_, r) => fmtDate(r?.createdAt) },
            { title: "Activity", key: "activity", width: 170, render: (_, r) => activityLabelFor(r) },
            { title: "Wallet", key: "walletType", width: 80, render: (_, r) => r?.walletType ?? "-" },
            { title: "Token", key: "token", width: 70, render: (_, r) => r?.coinSymbol ?? "-" },
            {
              title: "Amount Changed", key: "amountChanged", width: 130,
              render: (_, r) => {
                const amt = r?.amountChanged;
                if (amt == null) return "-";
                const color = amt > 0 ? "#2e7d32" : amt < 0 ? "#d32f2f" : undefined;
                return <span style={{ color, fontWeight: 600 }}>{amt > 0 ? "+" : ""}{fmtActivityAmount(amt)}</span>;
              },
            },
            {
              title: "Balance (Before → After)", key: "balance", width: 190,
              render: (_, r) => (r?.balanceBefore == null && r?.balanceAfter == null)
                ? "-"
                : `${fmtActivityAmount(r?.balanceBefore)} → ${fmtActivityAmount(r?.balanceAfter)}`,
            },
            {
              title: "Order / Exchange", key: "order", width: 150,
              render: (_, r) => r?.orderId
                ? <span>{r.exchange ? <span className="badge bg-info" style={{ marginRight: 6 }}>{r.exchange}</span> : null}<CopyableHash value={r.orderId} sliceLen={10} /></span>
                : (r?.exchange ?? "-"),
            },
            {
              title: "Status", key: "status", width: 110,
              render: (_, r) => <span className={`badge ${activityStatusBadgeClass(r?.status)}`}>{r?.status ?? "-"}</span>,
            },
            {
              title: "Reference", key: "reference", width: 160,
              render: (_, r) => <CopyableHash value={r?.referenceId} sliceLen={12} />,
            },
            {
              title: "Note", key: "note",
              render: (_, r) => r?.meta?.utrNumber
                ? `UTR: ${r.meta.utrNumber}`
                : (r?.meta?.rejectReason || r?.meta?.note || r?.meta?.reason || r?.meta?.txHash || "-"),
            },
          ]}
        />
      )}
      {activityTotal > activityPageSize && (
        <CustomPagination
          key={activityPaginationKey}
          totalTabs={activityTotal}
          tabsPerPage={activityPageSize}
          handleChange={(p) => setActivityPage(p)}
          className={activityLoading ? "display-hide" : "display-flex"}
        />
      )}
    </div>
  );
};

// ─── main component ─────────────────────────────────────────────────────────

const UserProfileView = () => {
  const { id } = useParams();
  const history = useHistory();

  // Core user data
  const [data, setData] = useState();
  const [dataLoading, setDataLoading] = useState(true);

  // Summary counts (for stat cards)
  const [depositCount, setDepositCount] = useState(null);
  const [withdrawCount, setWithdrawCount] = useState(null);
  const [tradeCount, setTradeCount] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);

  // Tab 3 — balances
  const [fireblocksWallet, setFireblocksWallet] = useState(null);
  const [fundingWallet, setFundingWallet] = useState([]);
  const [spotWallet, setSpotWallet] = useState([]);
  const [walletLoading, setWalletLoading] = useState(false);

  // Tab 4 — transactions
  const [txList, setTxList] = useState([]);
  const [txTotal, setTxTotal] = useState(0);
  const [txPage, setTxPage] = useState(1);
  const [txType, setTxType] = useState("");
  const [txStatus, setTxStatus] = useState("");
  const [txCoin, setTxCoin] = useState("");
  const [txStartDate, setTxStartDate] = useState(null);
  const [txEndDate, setTxEndDate] = useState(null);
  const [txLoading, setTxLoading] = useState(false);

  // Tab 5 — orders
  const [orderList, setOrderList] = useState([]);
  const [orderTotal, setOrderTotal] = useState(0);
  const [orderPage, setOrderPage] = useState(1);
  const [orderLoading, setOrderLoading] = useState(false);

  // Tabs — deposits & withdrawals
  const [depList, setDepList] = useState([]);
  const [depTotal, setDepTotal] = useState(0);
  const [depPage, setDepPage] = useState(1);
  const [depPageSize, setDepPageSize] = useState(10);
  const [depStatus, setDepStatus] = useState("");
  const [depSearch, setDepSearch] = useState("");
  const [depStart, setDepStart] = useState(null);
  const [depEnd, setDepEnd] = useState(null);
  const [depLoading, setDepLoading] = useState(false);

  const [witList, setWitList] = useState([]);
  const [witTotal, setWitTotal] = useState(0);
  const [witPage, setWitPage] = useState(1);
  const [witPageSize, setWitPageSize] = useState(10);
  const [witStatus, setWitStatus] = useState("");
  const [witSearch, setWitSearch] = useState("");
  const [witStart, setWitStart] = useState(null);
  const [witEnd, setWitEnd] = useState(null);
  const [witLoading, setWitLoading] = useState(false);

  // Tab 6 — logs
  const [logList, setLogList] = useState([]);
  const [logCount, setLogCount] = useState(0);
  const [logType, setLogType] = useState("");
  const [logAction, setLogAction] = useState("");
  const [logActions, setLogActions] = useState([]);
  const [logSearch, setLogSearch] = useState("");
  const [logFrom, setLogFrom] = useState(moment().subtract(7, "days").toISOString());
  const [logTo, setLogTo] = useState(moment().toISOString());
  const [logLoading, setLogLoading] = useState(false);
  const [expandedLog, setExpandedLog] = useState(null);

  // Wallet Activity Log now lives entirely in the standalone
  // <UserActivityLogTab> component (module scope) — no state needed here.

  // Third-party
  const [thirdPartyData, setThirdPartyData] = useState(null);
  const [thirdPartyLoading, setThirdPartyLoading] = useState(false);

  // KYC Config
  const DEFAULT_KYC_SUB = { enabled: true, coolingPeriod: { value: 24, unit: "HOURS" } };
  const DEFAULT_KYC_FORM = { inrDeposit: null, inrWithdrawal: null, cryptoDeposit: null, cryptoWithdrawal: null };
  const TX_SUB_LABELS = [
    { key: "inrDeposit",       label: "INR Deposit" },
    { key: "inrWithdrawal",    label: "INR Withdrawal" },
    { key: "cryptoDeposit",    label: "Crypto Deposit" },
    { key: "cryptoWithdrawal", label: "Crypto Withdrawal" },
  ];
  const [kycConfigLoading, setKycConfigLoading] = useState(false);
  const [kycConfigSaving, setKycConfigSaving] = useState(false);
  const [kycUserForm, setKycUserForm] = useState(DEFAULT_KYC_FORM);
  const [kycResolved, setKycResolved] = useState(null);

  // Quick Actions
  const [qaModal, setQaModal] = useState(null); // { type: 'freeze'|'restrict'|'delete'|'reactivate', loading: bool }
  const [qaLoading, setQaLoading] = useState(false);

  // Bank verification admin actions
  const [bankApproveOpen, setBankApproveOpen] = useState(false);
  const [bankRejectOpen, setBankRejectOpen] = useState(false);
  const [bankRejectReason, setBankRejectReason] = useState("");
  const [bankRejectError, setBankRejectError] = useState(false);
  const [bankActionLoading, setBankActionLoading] = useState(false);

  // KYC redo trigger
  const [kycRedoOpen, setKycRedoOpen] = useState(false);
  const [kycRedoReason, setKycRedoReason] = useState("");
  const [kycRedoLoading, setKycRedoLoading] = useState(false);

  // KYC approve / reject (reason + email OTP). `kycDecision` is the action being confirmed.
  const [kycDecision, setKycDecision] = useState(null); // 'APPROVED' | 'REJECTED' | null (modal closed)
  const [kycDecisionReason, setKycDecisionReason] = useState("");
  const [kycDecisionReasonError, setKycDecisionReasonError] = useState(false);
  const [kycOtpSent, setKycOtpSent] = useState(false);
  const [kycOtpSentTo, setKycOtpSentTo] = useState([]);
  const [kycOtp, setKycOtp] = useState("");
  const [kycOtpError, setKycOtpError] = useState("");
  const [kycOtpSending, setKycOtpSending] = useState(false);
  const [kycDecisionLoading, setKycDecisionLoading] = useState(false);
  const [kycHistory, setKycHistory] = useState([]);
  const [kycHistoryLoading, setKycHistoryLoading] = useState(false);

  // Block / Unblock — reason required for block, optional for unblock.
  const [blockOpen, setBlockOpen] = useState(false);
  const [blockAction, setBlockAction] = useState(false); // true = blocking, false = unblocking
  const [blockReason, setBlockReason] = useState("");
  const [blockReasonError, setBlockReasonError] = useState(false);
  const [blockLoading, setBlockLoading] = useState(false);

  const openBlockModal = (isBlocking) => {
    setBlockAction(isBlocking);
    setBlockReason("");
    setBlockReasonError(false);
    setBlockOpen(true);
  };

  const handleBlockConfirm = () => {
    if (blockAction && !blockReason.trim()) {
      setBlockReasonError(true);
      return;
    }
    if (blockLoading || !id) return;
    setBlockLoading(true);
    blockUserWithReason(id, {
      block: blockAction,
      reason: blockReason.trim(),
    })
      ?.then((res) => {
        if (res?.status) {
          toast.success(res?.message, { toastId: 'user-profile-block-success' });
          // Refresh the local user data so the panel updates inline.
          getUserById(id)?.then((r) => {
            if (r?.status) setData(r.data);
          });
          setBlockOpen(false);
          setBlockReason("");
        } else {
          toast.error(res?.message || "Failed to update block status", { toastId: 'user-profile-block-error' });
        }
      })
      ?.catch((e) => {
        toast.error(
          e?.response?.data?.message || "Failed to update block status",
          { toastId: 'user-profile-block-error' },
        );
      })
      ?.finally(() => setBlockLoading(false));
  };

  // Lazy-load tracking
  const loadedTabs = useRef(new Set(["overview"]));
  const [activeTabKey, setActiveTabKey] = useState("overview");

  // ── fetch user ────────────────────────────────────────────────────────────

  useEffect(() => {
    if (!id) return;
    setDataLoading(true);
    getUserById(id)?.then((res) => {
      if (res?.status) setData(res.data);
      setDataLoading(false);
    });

    // Summary stats — INR deposit/withdraw counts come from coin_withdrawal via
    // getInrTransactionCounts (the crypto UserWalletTransaction ledger has no
    // INR rows, so the old CREDIT/DEBIT calls always returned 0). Trades still
    // come from admin/order.
    setStatsLoading(true);
    Promise.allSettled([
      getInrTransactionCounts({ userId: id }),
      getOrderCoinDcx({ userId: id, page: 1, sizePerPage: 1, pagination: true }),
    ]).then(([inr, trd]) => {
      if (inr.status === "fulfilled") {
        const d = inr.value?.data ?? inr.value;
        setDepositCount(d?.depositCount ?? null);
        setWithdrawCount(d?.withdrawCount ?? null);
      }
      if (trd.status === "fulfilled") {
        const d = trd.value?.data ?? trd.value;
        setTradeCount(d?.total ?? null);
      }
      setStatsLoading(false);
    });
  }, [id]);

  // ── tab 4 — transactions ──────────────────────────────────────────────────

  const fetchTransactions = (page = 1) => {
    if (!id) return;
    setTxLoading(true);
    const params = { userId: id, page, sizePerPage: 10, pagination: true };
    if (txType)      params.type       = txType;
    if (txStatus)    params.status     = txStatus;
    if (txCoin)      params.coinSymbol = txCoin;
    if (txStartDate) params.startDate  = txStartDate;
    if (txEndDate)   params.endDate    = txEndDate;
    getUserWalletTrx(params).then((res) => {
      const d = res?.data ?? res;
      setTxList(d?.result ?? d?.docs ?? []);
      setTxTotal(d?.total ?? 0);
      setTxLoading(false);
    }).catch(() => setTxLoading(false));
  };

  useEffect(() => {
    if (loadedTabs.current.has("transactions")) fetchTransactions(txPage);
  }, [txPage, txType, txStatus, txCoin, txStartDate, txEndDate]);

  // ── deposits & withdrawals tabs ───────────────────────────────────────────

  useEffect(() => {
    setDepPage(1);
  }, [depPageSize, depStatus, depSearch, depStart, depEnd]);

  useEffect(() => {
    setWitPage(1);
  }, [witPageSize, witStatus, witSearch, witStart, witEnd]);

  // ── deposits & withdrawals tabs ───────────────────────────────────────────

  const fetchDeposits = () => {
    if (!id) return;
    setDepLoading(true);
    const params = {
      userId: id,
      type: "DEPOSIT",
      page: depPage,
      sizePerPage: depPageSize,
      pagination: true,
    };
    if (depStatus) params.status = depStatus;
    if (depSearch) params.search = depSearch;
    if (depStart) params.startDate = depStart;
    if (depEnd) params.endDate = depEnd;
    getWithdrawalReq(params)
      .then((res) => {
        if (res?.status) {
          setDepList(res?.data?.result || []);
          setDepTotal(res?.data?.total || 0);
        }
      })
      .finally(() => setDepLoading(false));
  };

  const fetchWithdrawals = () => {
    if (!id) return;
    setWitLoading(true);
    const params = {
      userId: id,
      type: "WITHDRAW",
      page: witPage,
      sizePerPage: witPageSize,
      pagination: true,
    };
    if (witStatus) params.status = witStatus;
    if (witSearch) params.search = witSearch;
    if (witStart) params.startDate = witStart;
    if (witEnd) params.endDate = witEnd;
    getWithdrawalReq(params)
      .then((res) => {
        if (res?.status) {
          setWitList(res?.data?.result || []);
          setWitTotal(res?.data?.total || 0);
        }
      })
      .finally(() => setWitLoading(false));
  };

  useEffect(() => {
    if (loadedTabs.current.has("deposits")) fetchDeposits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depPage, depPageSize, depStatus, depSearch, depStart, depEnd]);

  useEffect(() => {
    if (loadedTabs.current.has("withdrawals")) fetchWithdrawals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [witPage, witPageSize, witStatus, witSearch, witStart, witEnd]);

  useEffect(() => {
    setDepPage(1);
  }, [depPageSize, depStatus, depSearch, depStart, depEnd]);

  useEffect(() => {
    setWitPage(1);
  }, [witPageSize, witStatus, witSearch, witStart, witEnd]);

  // ── tab 5 — orders ────────────────────────────────────────────────────────

  const fetchOrders = (page = 1) => {
    if (!id) return;
    setOrderLoading(true);
    // Use admin/order (getOrderCoinDcx) — same source as the Order list page
    getOrderCoinDcx({ userId: id, page, sizePerPage: 10, pagination: true }).then((res) => {
      console.log("%c Line:255 🥕 res", "color:#e41a6a", res);
      const d = res?.data ?? res;
      setOrderList(d?.result ?? d?.docs ?? []);
      setOrderTotal(d?.total ?? 0);
      setOrderLoading(false);
    }).catch(() => setOrderLoading(false));
  };

  useEffect(() => {
    if (loadedTabs.current.has("orders")) fetchOrders(orderPage);
  }, [orderPage]);

  // ── tab 6 — logs ──────────────────────────────────────────────────────────

  const fetchLogs = () => {
    if (!id) return;
    setLogLoading(true);
    getLogsApi({ userId: id, from: logFrom, to: logTo, limit: 200, ...(logType && { type: logType }), ...(logAction && { action: logAction }), ...(logSearch && { search: logSearch }) })
      .then((res) => {
        const d = res?.data ?? res;
        setLogList(d?.logs ?? []);
        setLogCount(d?.count ?? 0);
        setLogLoading(false);
      })
      .catch(() => setLogLoading(false));
  };

  useEffect(() => {
    if (loadedTabs.current.has("logs")) fetchLogs();
  }, [logType, logAction, logSearch, logFrom, logTo]);

  const fetchKycConfig = async () => {
    if (!id) return;
    setKycConfigLoading(true);
    try {
      const [userRes, resolvedRes] = await Promise.allSettled([
        getUserKycConfig(id),
        getResolvedKycConfig(id),
      ]);
      if (userRes.status === "fulfilled") {
        const d = userRes.value?.data ?? userRes.value;
        setKycUserForm(d ?? DEFAULT_KYC_FORM);
      }
      if (resolvedRes.status === "fulfilled") {
        const d = resolvedRes.value?.data ?? resolvedRes.value;
        setKycResolved(d ?? null);
      }
    } catch {
      toast.error("Failed to load transaction config", { toastId: "kyc-config-load" });
    } finally {
      setKycConfigLoading(false);
    }
  };

  // ── tab activation ────────────────────────────────────────────────────────

  const handleTabChange = (key) => {
    setActiveTabKey(key);
    if (loadedTabs.current.has(key)) return;
    loadedTabs.current.add(key);
    if (key === "balances") {
      setWalletLoading(true);
      Promise.allSettled([
        getUserFireblocksWallet(id),
        getUserWalletByType(id, "FUNDING"),
        getUserWalletByType(id, "SPOT"),
      ]).then(([fbResult, fundResult, spotResult]) => {
        if (fbResult.status === "fulfilled") {
          setFireblocksWallet(fbResult.value?.data ?? fbResult.value ?? null);
        }
        if (fundResult.status === "fulfilled") {
          const d = fundResult.value?.data ?? fundResult.value;
          setFundingWallet(d?.[0]?.data ?? d?.result ?? d ?? []);
        }
        if (spotResult.status === "fulfilled") {
          const d = spotResult.value?.data ?? spotResult.value;
          setSpotWallet(d?.[0]?.data ?? d?.result ?? d ?? []);
        }
        setWalletLoading(false);
      });
    }
    if (key === "transactions") fetchTransactions(1);
    if (key === "deposits") fetchDeposits();
    if (key === "withdrawals") fetchWithdrawals();
    if (key === "orders") fetchOrders(1);
    if (key === "logs") {
      getLogActionsApi().then((res) => {
        const d = res?.data ?? res;
        setLogActions(d?.actions ?? []);
      });
      fetchLogs();
    }
    // walletActivityLog is self-loading — <UserActivityLogTab active={...}>
    // fetches its own data the first time it becomes active.
    if (key === "kyc") loadKycHistory();
    if (key === "kyc-config") fetchKycConfig();
  };

  // ── quick actions ─────────────────────────────────────────────────────────

  const handleQuickAction = async () => {
    if (!qaModal) return;
    setQaLoading(true);
    try {
      let res;
      if (qaModal === "freeze") res = await freezeUserAccount(id);
      else if (qaModal === "restrict") res = await restrictUserWithdrawal(id);
      else if (qaModal === "delete") res = await deleteUser(id);
      else if (qaModal === "reactivate") res = await reactivateUser(id);
      else if (qaModal === "deactivate") res = await deactivateUser(id);
      else if (qaModal === "activate") res = await activateUser(id);

      if (res?.status) {
        // Refresh user data to reflect new state
        getUserById(id).then((r) => setData(r?.data ?? r)).catch(() => {});
      }
    } catch (_) {}
    setQaLoading(false);
    setQaModal(null);
  };

  // ── bank verification & KYC redo actions ──────────────────────────────────

  const refreshUser = () => {
    if (!id) return;
    getUserById(id)
      .then((r) => setData(r?.data ?? r))
      .catch(() => {});
  };

  const handleApproveBank = async () => {
    setBankActionLoading(true);
    try {
      const res = await approveUserBank(id);
      if (res?.status) {
        refreshUser();
      }
    } catch (_) {}
    setBankActionLoading(false);
    setBankApproveOpen(false);
  };

  const handleRejectBank = async () => {
    if (!bankRejectReason.trim()) {
      setBankRejectError(true);
      return;
    }
    setBankActionLoading(true);
    try {
      const res = await rejectUserBank(id, { reason: bankRejectReason.trim() });
      if (res?.status) {
        refreshUser();
      }
    } catch (_) {}
    setBankActionLoading(false);
    setBankRejectOpen(false);
    setBankRejectReason("");
    setBankRejectError(false);
  };

  // ── KYC approve / reject with reason + email OTP ──────────────────────────
  const loadKycHistory = () => {
    if (!id) return;
    setKycHistoryLoading(true);
    getKycReviewHistory(id)
      .then((r) => setKycHistory(r?.data?.history ?? []))
      .catch(() => {})
      .finally(() => setKycHistoryLoading(false));
  };

  // Reason is mandatory for every reject, and for an approve that follows a reject or
  // goes against Digio's rejection (the backend enforces the same rule).
  const kycReasonRequired = (decision) =>
    decision === "REJECTED" ||
    String(data?.kycStatus || "").toUpperCase() === "REJECTED" ||
    data?.kycReview?.digioStatus === "REJECTED";

  const openKycDecision = (decision) => {
    setKycDecision(decision);
    setKycDecisionReason("");
    setKycDecisionReasonError(false);
    setKycOtpSent(false);
    setKycOtpSentTo([]);
    setKycOtp("");
    setKycOtpError("");
  };

  const closeKycDecision = () => {
    if (kycDecisionLoading) return;
    setKycDecision(null);
    setKycOtp("");
    setKycOtpError("");
  };

  const handleSendKycOtp = async (isResend = false) => {
    if (kycReasonRequired(kycDecision) && !kycDecisionReason.trim()) {
      setKycDecisionReasonError(true);
      return;
    }
    setKycOtpSending(true);
    setKycOtpError("");
    try {
      const fn = isResend ? resendKycReviewOtp : sendKycReviewOtp;
      const res = await fn(id, { decision: kycDecision });
      if (res?.status) {
        setKycOtpSent(true);
        setKycOtpSentTo(res?.data?.sentTo ?? []);
        setKycOtp("");
        toast.success(res?.message || "OTP sent", { toastId: "user-profile-kyc-otp-sent" });
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to send OTP", { toastId: "user-profile-kyc-otp-error" });
    }
    setKycOtpSending(false);
  };

  const handleConfirmKycDecision = async () => {
    if (kycReasonRequired(kycDecision) && !kycDecisionReason.trim()) {
      setKycDecisionReasonError(true);
      return;
    }
    if (!kycOtpSent || kycOtp.length !== 6) return;
    setKycDecisionLoading(true);
    setKycOtpError("");
    try {
      const res = await decideKycReview(id, {
        decision: kycDecision,
        reason: kycDecisionReason.trim() || undefined,
        otp: kycOtp.trim(),
      });
      if (res?.status) {
        toast.success(res?.message || "KYC updated", { toastId: "user-profile-kyc-decision-success" });
        setKycDecision(null);
        refreshUser();
        loadKycHistory();
      }
    } catch (e) {
      const msg = e?.response?.data?.message || "Failed to update KYC";
      if (/otp/i.test(msg)) setKycOtpError(msg);
      else toast.error(msg, { toastId: "user-profile-kyc-decision-error" });
    }
    setKycDecisionLoading(false);
  };

  const handleTriggerKycRedo = async () => {
    setKycRedoLoading(true);
    try {
      const res = await triggerKycRedo(id, {
        reason: kycRedoReason.trim() || undefined,
      });
      if (res?.status) {
        refreshUser();
      }
    } catch (_) {}
    setKycRedoLoading(false);
    setKycRedoOpen(false);
    setKycRedoReason("");
  };

  // ── third-party fetch ─────────────────────────────────────────────────────

  const handleFetchThirdParty = () => {
    setThirdPartyLoading(true);
    getUserThirdPartyData(id)
      .then((res) => {
        setThirdPartyData(res?.data ?? res);
        setThirdPartyLoading(false);
      })
      .catch(() => setThirdPartyLoading(false));
  };

  // ─── derived ─────────────────────────────────────────────────────────────
  const eddDocs = data ? parseEddDocs(data.eddDocs) : [];
  const eddOldDocs = data ? parseOldEddDocs(data.eddOldDocs) : [];

  // ─── TAB CONTENT ─────────────────────────────────────────────────────────

  const OverviewTab = () => (
    <div style={{ padding: "16px 0" }}>
      {/* Summary stat cards */}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 24 }}>
        <StatCard label="Total Deposits" value={depositCount} loading={statsLoading} />
        <StatCard label="Total Withdrawals" value={withdrawCount} loading={statsLoading} />
        <StatCard label="Total Trades" value={tradeCount} loading={statsLoading} />
        <StatCard label="Risk Score" value={data?.riskAssessment?.score} loading={dataLoading} />
      </div>

      <DetailSection title="Profile">
        <DetailRow label="ID" mono>{data?._id}</DetailRow>
        <DetailRow label="First Name">{data?.firstName}</DetailRow>
        <DetailRow label="Last Name">{data?.lastName}</DetailRow>
        <DetailRow label="User ID">{data?.userId}</DetailRow>
        <DetailRow label="Email">{data?.email}</DetailRow>
        <DetailRow label="Phone">{data?.phoneNumber}</DetailRow>
        <DetailRow label="Referral Code">{data?.refral}</DetailRow>
      </DetailSection>

      <DetailSection title="Account Status">
        <DetailRow label="Account Status">{data?.accountStatus}</DetailRow>
        <DetailRow label="Blocked">{renderBool(data?.isBlock)}</DetailRow>
        <DetailRow label="Frozen">
          <span style={{ color: data?.isFrozen ? "#e65100" : "#2e7d32", fontWeight: 600 }}>
            {data?.isFrozen ? "Yes — Account Frozen" : "No"}
          </span>
        </DetailRow>
        <DetailRow label="Withdraw Restricted">
          <span style={{ color: data?.withdrawRestricted ? "#b71c1c" : "#2e7d32", fontWeight: 600 }}>
            {data?.withdrawRestricted ? "Yes — Withdrawals Restricted" : "No"}
          </span>
        </DetailRow>
        <DetailRow label="Deleted">{renderBool(data?.isDeleted)}</DetailRow>
        <DetailRow label="Email Verified">{renderBool(data?.isEmailVerified)}</DetailRow>
        <DetailRow label="Mobile Verified">{renderBool(data?.isMobileVerified)}</DetailRow>
        <DetailRow label="2FA Enabled">{renderBool(data?.enabled2fa)}</DetailRow>
        <DetailRow label="KYC Status">{data?.kycStatus}</DetailRow>
        <DetailRow label="KYC Retry Count">{data?.kycRetryCount}</DetailRow>
        <DetailRow label="KYC Level">{data?.kycLevel}</DetailRow>
        <DetailRow label="EDD Status">{data?.eddStatus}</DetailRow>
      </DetailSection>

      <DetailSection title="Personal">
        <DetailRow label="Date of Birth">{data?.dob ? moment(data.dob).format("DD/MM/YYYY") : null}</DetailRow>
        <DetailRow label="Gender">{data?.kyc?.gender === "M" ? "Male" : data?.kyc?.gender === "F" ? "Female" : data?.kyc?.gender}</DetailRow>
        <DetailRow label="Occupation">{data?.occupation}</DetailRow>
        <DetailRow label="Income">{incomeLabel(data?.income)}</DetailRow>
        <DetailRow label="PEP">{data?.pep}</DetailRow>
        <DetailRow label="Nationality">{data?.nationality ?? data?.kyc?.nationality}</DetailRow>
        <DetailRow label="Country">{data?.country}</DetailRow>
      </DetailSection>

      <DetailSection title="Address">
        <DetailRow label="Line 1">{data?.address?.addressLine1}</DetailRow>
        <DetailRow label="Line 2">{data?.address?.addressLine2}</DetailRow>
        <DetailRow label="City">{data?.address?.city}</DetailRow>
        <DetailRow label="State">{data?.address?.state}</DetailRow>
        <DetailRow label="Pincode">{data?.address?.pinCode}</DetailRow>
      </DetailSection>

      <DetailSection title="Meta">
        <DetailRow label="Joined">{fmtDate(data?.createdAt)}</DetailRow>
        <DetailRow label="Updated">{fmtDate(data?.updatedAt)}</DetailRow>
      </DetailSection>

      {data?.blockHistory && data.blockHistory.length > 0 && (
        <DetailSection title="Block History">
          <div style={{ padding: "4px 16px" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "#f5f5f5" }}>
                  <th style={{ padding: "6px 10px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #e0e0e0" }}>Action</th>
                  <th style={{ padding: "6px 10px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #e0e0e0" }}>Reason</th>
                  <th style={{ padding: "6px 10px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #e0e0e0" }}>Admin</th>
                  <th style={{ padding: "6px 10px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #e0e0e0" }}>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {[...data?.blockHistory]?.reverse()?.map((entry, i) => (
                  <tr key={i} style={{ borderBottom: "1px solid #f0f0f0" }}>
                    <td style={{ padding: "6px 10px" }}>
                      <span style={{ color: entry?.action === "BLOCKED" ? "#b71c1c" : "#2e7d32", fontWeight: 600 }}>
                        {entry?.action}
                      </span>
                    </td>
                    <td style={{ padding: "6px 10px", color: "#555" }}>{entry?.reason || "—"}</td>
                    <td style={{ padding: "6px 10px", color: "#555" }}>
                      {entry?.adminName && entry?.adminEmail ? (
                        <>
                          {entry?.adminName}
                          <span style={{ color: "#888", marginLeft: 6, fontSize: 11 }}>
                            ({entry?.adminEmail})
                          </span>
                        </>
                      ) : (
                        entry?.adminName || entry?.adminEmail || entry?.adminId || "—"
                      )}
                    </td>
                    <td style={{ padding: "6px 10px", color: "#888" }}>{entry?.timestamp ? fmtDate(entry?.timestamp) : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DetailSection>
      )}
    </div>
  );

  const KycTab = () => (
    <div style={{ padding: "16px 0" }}>
      {/* Digio result held for admin review / latest admin decision + approve & reject */}
      {(() => {
        // Nothing to review until the user has started KYC (Digio application id exists).
        if (!data?.kyc?.applicationId) return null;
        const review = data?.kycReview;
        const status = String(data?.kycStatus || "").toUpperCase();
        const pending = review?.state === "PENDING_REVIEW" && review?.digioStatus;
        const decided = review?.state === "DECIDED" && review?.decision;
        const digioApproved = review?.digioStatus === "APPROVED";
        // Outcome Digio itself gave when nothing is held for review (auto-processed).
        // Older users have no kycReview record — their Digio result only exists in the history log
        // (newest first), so look there before falling back to kyc.status.
        const digioHistoryRow = kycHistory.find(
          (h) => h.by === "digio" && ["APPROVED", "REJECTED"].includes(String(h.status || "").toUpperCase()),
        );
        const digioOutcome = String(
          review?.digioStatus || digioHistoryRow?.status || data?.kyc?.status || "",
        ).toUpperCase();
        const tone = pending
          ? digioApproved
            ? { bg: "#e8f7ee", border: "#0a7a3b", fg: "#0a7a3b" }
            : { bg: "#fee2e7", border: "#a8001f", fg: "#a8001f" }
          : decided
          ? review.decision === "APPROVED"
            ? { bg: "#e8f7ee", border: "#0a7a3b", fg: "#0a7a3b" }
            : { bg: "#fee2e7", border: "#a8001f", fg: "#a8001f" }
          : digioOutcome === "APPROVED"
          ? { bg: "#e8f7ee", border: "#0a7a3b", fg: "#0a7a3b" }
          : digioOutcome === "REJECTED"
          ? { bg: "#fee2e7", border: "#a8001f", fg: "#a8001f" }
          : { bg: "#f5f5f5", border: "#ccc", fg: "#555" };
        return (
          <div style={{ background: tone.bg, border: `1px solid ${tone.border}`, borderRadius: 8, padding: "14px 16px", marginBottom: 20 }}>
            <div style={{ fontWeight: 700, color: tone.fg, marginBottom: 4 }}>
              {pending
                ? `Digio result: ${review.digioStatus} — awaiting admin decision`
                : decided
                ? `KYC ${review.decision} by admin`
                : digioOutcome === "APPROVED" || digioOutcome === "REJECTED"
                ? `KYC ${digioOutcome} by Digio`
                : "No Digio result waiting for review"}
            </div>
            <div style={{ fontSize: 13, color: "#444", lineHeight: 1.6 }}>
              {pending && (
                <>
                  Received {fmtDate(review.digioReceivedAt) || "—"}. The user stays <b>{status || "—"}</b> until an admin decides.
                  {review.digioReason ? <> Digio reason: {review.digioReason}.</> : null}
                </>
              )}
              {decided && (
                <>
                  {review.decidedByAdminName || review.decidedByAdminEmail || "Admin"}
                  {review.decidedByAdminName && review.decidedByAdminEmail ? ` (${review.decidedByAdminEmail})` : ""} on{" "}
                  {fmtDate(review.decidedAt) || "—"}
                  {review.decisionReason ? <> — Reason: {review.decisionReason}</> : null}
                  {review.digioStatus ? <> · Digio said {review.digioStatus}</> : null}
                </>
              )}
              {!pending && !decided && (
                <>
                  {digioOutcome === "APPROVED" || digioOutcome === "REJECTED" ? (
                    <>
                      Digio {digioOutcome.toLowerCase()} this user's KYC (request id: <b>{data.kyc.applicationId}</b>).{" "}
                    </>
                  ) : null}
                  Current KYC status: <b>{status || "—"}</b>. You can still approve or reject manually, as per your risk assessment.
                </>
              )}
            </div>
            <PermissionGate module="user" action="update">
              <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                {status !== "APPROVED" && (
                  <button
                    onClick={() => openKycDecision("APPROVED")}
                    style={{ padding: "7px 16px", border: "none", borderRadius: 6, background: "#0a7a3b", color: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600 }}
                  >
                    Approve KYC
                  </button>
                )}
                {status !== "REJECTED" && (
                  <button
                    onClick={() => openKycDecision("REJECTED")}
                    style={{ padding: "7px 16px", border: "none", borderRadius: 6, background: "#a8001f", color: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600 }}
                  >
                    Reject KYC
                  </button>
                )}
              </div>
            </PermissionGate>
          </div>
        );
      })()}

      {/* Third-party fetch button */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <Button variant="outlined" size="small" onClick={handleFetchThirdParty} disabled={thirdPartyLoading}>
          Fetch Live Third-Party Data
        </Button>
        {thirdPartyLoading && <Spin size="small" />}
      </div>

      {thirdPartyData && (
        <DetailSection title="Live Third-Party Data">
          <Collapse
            style={{ marginBottom: 8 }}
            items={[
              {
                key: "digio",
                label: thirdPartyData.digio ? "Digio KYC Response" : "Digio — No data",
                children: thirdPartyData.digio ? (
                  <pre style={{ fontSize: 12, maxHeight: 400, overflowY: "auto", background: "#f5f5f5", padding: 12, borderRadius: 4 }}>
                    {JSON.stringify(thirdPartyData.digio, null, 2)}
                  </pre>
                ) : (
                  <span style={{ color: "#888" }}>No Digio KYC data found for this user.</span>
                ),
              },
              {
                key: "ca",
                label: thirdPartyData.complyAdvantage ? "ComplyAdvantage Workflow" : "ComplyAdvantage — No data",
                children: thirdPartyData.complyAdvantage ? (
                  <pre style={{ fontSize: 12, maxHeight: 400, overflowY: "auto", background: "#f5f5f5", padding: 12, borderRadius: 4 }}>
                    {JSON.stringify(thirdPartyData.complyAdvantage, null, 2)}
                  </pre>
                ) : (
                  <span style={{ color: "#888" }}>No ComplyAdvantage data found for this user.</span>
                ),
              },
            ]}
          />
          {thirdPartyData.errors?.length > 0 && (
            <div style={{ color: "#d32f2f", fontSize: 12, marginTop: 8 }}>
              Errors: {thirdPartyData.errors.join(" | ")}
            </div>
          )}
        </DetailSection>
      )}

      <DetailSection title="KYC Details">
        <DetailRow label="Application ID" mono>{data?.kyc?.applicationId}</DetailRow>
        <DetailRow label="Status">
          {data?.kyc?.status}
          {data?.kycRedoRequired ? (
            <span
              style={{
                marginLeft: 8,
                display: "inline-block",
                padding: "2px 10px",
                borderRadius: 12,
                fontSize: 11,
                fontWeight: 700,
                background: "#fee2e7",
                color: "#a8001f",
                border: "1px solid #F6465D",
              }}
            >
              REDO REQUIRED
            </span>
          ) : null}
        </DetailRow>
        <DetailRow label="Submitted">{renderBool(data?.kyc?.submitted)}</DetailRow>
        <DetailRow label="Submitted On">{fmtDate(data?.kyc?.isSubmittedOn)}</DetailRow>
        <DetailRow label="First Name">{data?.kyc?.firstName}</DetailRow>
        <DetailRow label="Last Name">{data?.kyc?.lastName}</DetailRow>
        <DetailRow label="Middle Name">{data?.kyc?.middleName}</DetailRow>
        <DetailRow label="Legal Name">{data?.kyc?.legalName}</DetailRow>
        <DetailRow label="Gender">{data?.kyc?.gender === "M" ? "Male" : data?.kyc?.gender === "F" ? "Female" : data?.kyc?.gender}</DetailRow>
        <DetailRow label="Date of Birth">{data?.kyc?.dob ? moment(data.kyc.dob).format("DD/MM/YYYY") : null}</DetailRow>
        <DetailRow label="PAN">{data?.kyc?.pan}</DetailRow>
        <DetailRow label="Aadhar">{data?.kyc?.aadhar}</DetailRow>
        <DetailRow label="Nationality">{data?.kyc?.nationality}</DetailRow>
        <DetailRow label="Country of Residance">{data?.kyc?.countryOfResidance}</DetailRow>
        <DetailRow label="Country of Issue">{data?.kyc?.countryOfIssue}</DetailRow>
        <DetailRow label="Tax Resistance Country">{data?.kyc?.taxResistanceCountry}</DetailRow>
        <DetailRow label="Current Address">{data?.kyc?.currentAddress}</DetailRow>
        <DetailRow label="State">{data?.kyc?.state}</DetailRow>
        <DetailRow label="Pincode">{data?.kyc?.pincode}</DetailRow>
        <DetailRow label="Selfie Confidence">{data?.kyc?.selfieConfidence}</DetailRow>
        <DetailRow label="Reason">{data?.kyc?.reason}</DetailRow>
        <DetailRow label="Digio Result">{data?.kycReview?.digioStatus}</DetailRow>
        <DetailRow label="Decision">{data?.kycReview?.decision}</DetailRow>
        <DetailRow label="Decided By">
          {data?.kycReview?.decidedByAdminName || data?.kycReview?.decidedByAdminEmail
            ? `${data?.kycReview?.decidedByAdminName || ""}${data?.kycReview?.decidedByAdminName && data?.kycReview?.decidedByAdminEmail ? " " : ""}${data?.kycReview?.decidedByAdminEmail ? `(${data.kycReview.decidedByAdminEmail})` : ""}`
            : null}
        </DetailRow>
        <DetailRow label="Decided At">{fmtDate(data?.kycReview?.decidedAt)}</DetailRow>
        <DetailRow label="Decision Reason">{data?.kycReview?.decisionReason}</DetailRow>
      </DetailSection>

      <DetailSection title="KYC Decision History">
        {kycHistoryLoading ? (
          <div style={{ padding: 12 }}><Spin size="small" /></div>
        ) : kycHistory.length === 0 ? (
          <div style={{ padding: 12, color: "#888", fontSize: 13 }}>No KYC decisions recorded yet.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "#f5f5f5" }}>
                  {["Date & time", "Event", "By", "Reason", "Status change"].map((h) => (
                    <th key={h} style={{ padding: "6px 10px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #e0e0e0" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {kycHistory.map((h) => {
                  const label =
                    h.event === "kyc_admin_approved" || h.event === "kyc_approved" ? "Admin approved"
                    : h.event === "kyc_admin_rejected" || h.event === "kyc_rejected" ? "Admin rejected"
                    : h.event === "kyc_redo_triggered" ? "Re-do triggered"
                    : h.event === "digio_result_pending_admin_review" ? `Digio ${String(h.status || "").toLowerCase()}`
                    : h.event === "digio_result_after_admin_decision" ? `Digio ${String(h.status || "").toLowerCase()} (after admin decision)`
                    : h.event;
                  const isAdmin = h.by === "admin";
                  return (
                    <tr key={h.id} style={{ borderBottom: "1px solid #f0f0f0" }}>
                      <td style={{ padding: "6px 10px", color: "#888", whiteSpace: "nowrap" }}>{fmtDate(h.at) || "—"}</td>
                      <td style={{ padding: "6px 10px", fontWeight: 600, color: /reject/i.test(label) ? "#a8001f" : /approv/i.test(label) ? "#0a7a3b" : "#333" }}>{label}</td>
                      <td style={{ padding: "6px 10px", color: "#555" }}>
                        {isAdmin ? (
                          <>
                            {h.adminName || h.adminEmail || "—"}
                            {h.adminName && h.adminEmail ? <span style={{ color: "#888", marginLeft: 6, fontSize: 11 }}>({h.adminEmail})</span> : null}
                          </>
                        ) : h.by === "digio" ? "Digio" : "—"}
                      </td>
                      <td style={{ padding: "6px 10px", color: "#555" }}>{h.reason || "—"}</td>
                      <td style={{ padding: "6px 10px", color: "#555", whiteSpace: "nowrap" }}>
                        {h.previousStatus && h.newStatus ? `${h.previousStatus} → ${h.newStatus}` : "—"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </DetailSection>

      {(data?.kyc?.documentFrontImage || data?.kyc?.documentBackImage || data?.kyc?.userSelfie) && (
        <DetailSection title="KYC Documents">
          <DocGrid
            files={[
              data?.kyc?.documentFrontImage && classifyFile(data.kyc.documentFrontImage, "Front"),
              data?.kyc?.documentBackImage && classifyFile(data.kyc.documentBackImage, "Back"),
              data?.kyc?.userSelfie && classifyFile(data.kyc.userSelfie, "Selfie"),
            ].filter(Boolean)}
          />
        </DetailSection>
      )}

      <DetailSection title="Bank Details">
        <DetailRow label="Status">
          {(() => {
            const s = data?.bankVerificationStatus || "NOT_ADDED";
            const map = {
              APPROVED: { bg: "#e6faf0", color: "#0a7a3b", border: "#0ECB81" },
              PENDING: { bg: "#fff8e1", color: "#a06900", border: "#F0B90B" },
              REJECTED: { bg: "#fee2e7", color: "#a8001f", border: "#F6465D" },
              NOT_ADDED: { bg: "#f1f3f5", color: "#555", border: "#ced4da" },
            };
            const c = map[s];
            return (
              <span
                style={{
                  display: "inline-block",
                  padding: "2px 10px",
                  borderRadius: 12,
                  fontSize: 11,
                  fontWeight: 700,
                  background: c.bg,
                  color: c.color,
                  border: `1px solid ${c.border}`,
                }}
              >
                {s.replace("_", " ")}
              </span>
            );
          })()}
        </DetailRow>
        <DetailRow label="Account Holder">{data?.bankAccountHolder}</DetailRow>
        <DetailRow label="Bank Name">{data?.bankName}</DetailRow>
        <DetailRow label="Account Number">{data?.bankAccountNumber}</DetailRow>
        <DetailRow label="IFSC">{data?.bankIfsc}</DetailRow>
        <DetailRow label="Verified At">{fmtDate(data?.bankVerifiedAt)}</DetailRow>
        <DetailRow label="Approved At">{fmtDate(data?.bankApprovedAt)}</DetailRow>
        <DetailRow label="Approved By">{data?.bankApprovedBy ? String(data.bankApprovedBy) : (data?.bankVerifiedAt && !data?.bankApprovedBy ? "System (auto)" : null)}</DetailRow>
        <DetailRow label="Digio Verification ID" mono>{data?.bankDigioVerificationId}</DetailRow>
        <DetailRow label="Rejection Reason">{data?.bankRejectionReason}</DetailRow>
        <DetailRow label="Name on Bank (Digio)">{data?.bankDetails?.beneficiary_name_with_bank}</DetailRow>
        {data?.bankVerificationStatus === "PENDING" && (
          <DetailRow label="Actions">
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() => setBankApproveOpen(true)}
                disabled={bankActionLoading}
                style={{
                  padding: "6px 14px",
                  border: "none",
                  borderRadius: 6,
                  background: "#0a7a3b",
                  color: "#fff",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Approve Bank
              </button>
              <button
                onClick={() => {
                  setBankRejectReason("");
                  setBankRejectError(false);
                  setBankRejectOpen(true);
                }}
                disabled={bankActionLoading}
                style={{
                  padding: "6px 14px",
                  border: "none",
                  borderRadius: 6,
                  background: "#a8001f",
                  color: "#fff",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Reject Bank
              </button>
            </div>
          </DetailRow>
        )}
      </DetailSection>

      {Array.isArray(data?.bankHistory) && data.bankHistory.length > 0 && (
        <DetailSection title="Bank Verification History">
          <Table
            pagination={false}
            size="small"
            rowKey={(r, i) => i}
            dataSource={[...data.bankHistory].reverse()}
            columns={[
              {
                title: "Closed At",
                key: "closedAt",
                render: (_, r) => fmtDate(r?.closedAt) || fmtDate(r?.createdAt) || "-",
              },
              {
                title: "Bank",
                key: "bank",
                render: (_, r) =>
                  `${r?.bankName || "-"} (${r?.bankAccountNumber || "-"})`,
              },
              { title: "IFSC", key: "ifsc", render: (_, r) => r?.bankIfsc || "-" },
              {
                title: "Status",
                key: "status",
                render: (_, r) => r?.status || "-",
              },
              {
                title: "Reason",
                key: "reason",
                render: (_, r) => r?.rejectionReason || "-",
              },
              {
                title: "Reviewed By",
                key: "reviewedBy",
                render: (_, r) => (r?.reviewedBy ? String(r.reviewedBy) : "-"),
              },
              {
                title: "Counted",
                key: "counted",
                render: (_, r) =>
                  r?.countedTowardLimit === false ? "No" : "Yes",
              },
            ]}
          />
        </DetailSection>
      )}

      {data?.riskAssessment && (
        <DetailSection title="Risk Assessment">
          {Object.entries(data.riskAssessment).map(([key, value]) => (
            <DetailRow key={key} label={key}>
              {typeof value === "object" ? JSON.stringify(value) : String(value ?? "")}
            </DetailRow>
          ))}
        </DetailSection>
      )}

      {data?.notabene && (
        <DetailSection title="Notabene">
          {Object.entries(data.notabene).map(([key, value]) => (
            <DetailRow key={key} label={key}>
              {typeof value === "object" ? JSON.stringify(value) : String(value ?? "")}
            </DetailRow>
          ))}
        </DetailSection>
      )}

      {data?.complyAdvantage && (
        <DetailSection title="ComplyAdvantage">
          <DetailRow label="Workflow ID" mono>{data.complyAdvantage}</DetailRow>
        </DetailSection>
      )}

      {(data?.bankChangeHistory || data?.emailChangeHistory || data?.phoneChangeHistory) && (
        <DetailSection title="Change History">
          {data?.emailChangeHistory && (
            <DetailRow label="Email History">
              <pre style={{ fontSize: 11, margin: 0 }}>
                {JSON.stringify(data.emailChangeHistory, null, 2)}
              </pre>
            </DetailRow>
          )}
          {data?.phoneChangeHistory && (
            <DetailRow label="Phone History">
              <pre style={{ fontSize: 11, margin: 0 }}>
                {JSON.stringify(data.phoneChangeHistory, null, 2)}
              </pre>
            </DetailRow>
          )}
          {data?.bankChangeHistory && (
            <DetailRow label="Bank History">
              <pre style={{ fontSize: 11, margin: 0 }}>
                {JSON.stringify(data.bankChangeHistory, null, 2)}
              </pre>
            </DetailRow>
          )}
        </DetailSection>
      )}

      <DetailSection title="EDD (Enhanced Due Diligence)">
        <DetailRow label="EDD Required">{renderBool(data?.edd)}</DetailRow>
        <DetailRow label="EDD Status">{data?.eddStatus}</DetailRow>
        {data?.eddDocs?.date && (
          <DetailRow label="EDD Submitted On">
            {fmtDate(data.eddDocs.date)}
          </DetailRow>
        )}
        {eddDocs.length > 0 ? (
          <DocGrid files={eddDocs} />
        ) : (
          <div style={{ padding: "10px 16px", color: "#888", fontSize: 13 }}>
            No EDD documents uploaded.
          </div>
        )}
      </DetailSection>

      {eddOldDocs.length > 0 && (
        <DetailSection title="EDD Previous Documents">
          <DocGrid files={eddOldDocs} />
        </DetailSection>
      )}
    </div>
  );

  const WalletTable = ({ data, emptyText }) => {
    if (!data || data.length === 0)
      return <div style={{ color: "#888", padding: "12px 16px", fontSize: 13 }}>{emptyText ?? "No records."}</div>;
    return (
      <Table
        pagination={false}
        size="small"
        style={{ marginTop: 8 }}
        rowKey={(r, i) => r?._id ?? i}
        dataSource={data}
        columns={[
          { title: "Coin", key: "coin", render: (_, r) => r?.coin?.symbol ?? r?.coin?.name ?? (typeof r?.coin === "string" ? r.coin : "-") },
          { title: "Amount", key: "amount", render: (_, r) => r?.amount ?? "-" },
          { title: "Reserved", key: "reserved", render: (_, r) => r?.reserved ?? "-" },
          { title: "Active", key: "active", width: 70, render: (_, r) => renderBool(r?.isActive) },
          { title: "Locked", key: "locked", width: 70, render: (_, r) => renderBool(r?.isLocked) },
          { title: "Frozen", key: "frozen", width: 70, render: (_, r) => renderBool(r?.isFrozen) },
        ]}
      />
    );
  };

  const BalancesTab = () => (
    <div style={{ padding: "16px 0" }}>
      {walletLoading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          <DetailSection title="Funding Wallet">
            <WalletTable data={fundingWallet} emptyText="No funding wallet balances found." />
          </DetailSection>

          <DetailSection title="Spot Wallet">
            <WalletTable data={spotWallet} emptyText="No spot wallet balances found." />
          </DetailSection>

          <DetailSection title="Fireblocks Wallet — Deposit Addresses">
            {fireblocksWallet ? (
              <>
                <DetailRow label="Vault Account ID" mono>
                  {fireblocksWallet?.fireblocksVaultAccountId ?? "—"}
                </DetailRow>
                {Array.isArray(fireblocksWallet?.assets) && fireblocksWallet.assets.length > 0 ? (
                  <Table
                    pagination={false}
                    size="small"
                    style={{ marginTop: 8 }}
                    rowKey={(r) => `${r?.assetId}-${r?.chain}`}
                    dataSource={fireblocksWallet.assets}
                    columns={[
                      { title: "Asset ID", dataIndex: "assetId", key: "assetId" },
                      { title: "Chain", dataIndex: "chain", key: "chain" },
                      { title: "Chain Type", dataIndex: "chainType", key: "chainType" },
                      {
                        title: "Deposit Address",
                        key: "address",
                        render: (_, r) => (
                          <span style={{ fontFamily: "monospace", fontSize: 11, wordBreak: "break-all" }}>
                            {r?.address || "—"}
                          </span>
                        ),
                      },
                      {
                        title: "Tag / Memo",
                        key: "tag",
                        render: (_, r) => r?.tag || "—",
                      },
                    ]}
                  />
                ) : (
                  <div style={{ color: "#888", padding: "12px 16px", fontSize: 13 }}>No deposit addresses found.</div>
                )}
              </>
            ) : (
              <div style={{ color: "#888", padding: "12px 16px", fontSize: 13 }}>No Fireblocks wallet data available.</div>
            )}
          </DetailSection>
        </>
      )}
    </div>
  );

  const txStatusColor = (s) => {
    if (!s) return {};
    const u = String(s).toUpperCase();
    if (u === "COMPLETED") return { color: "#16a34a", fontWeight: 600 };
    if (u === "PENDING" || u === "ON_HOLD") return { color: "#d97706", fontWeight: 600 };
    if (u === "FAILED" || u === "REJECTED" || u === "BLOCKED") return { color: "#dc2626", fontWeight: 600 };
    return {};
  };

  const txPaginationKey = `tx-${txType}-${txStatus}-${txCoin}-${txStartDate}-${txEndDate}`;

  const TransactionsTab = () => (
    <div style={{ padding: "16px 0" }}>
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
        <select
          value={txType}
          onChange={(e) => { setTxType(e.target.value); setTxPage(1); }}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13 }}
        >
          <option value="">All Types</option>
          <option value="CREDIT">Deposit (CREDIT)</option>
          <option value="DEBIT">Withdrawal (DEBIT)</option>
        </select>

        <select
          value={txStatus}
          onChange={(e) => { setTxStatus(e.target.value); setTxPage(1); }}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13 }}
        >
          <option value="">All Statuses</option>
          <option value="COMPLETED">Completed</option>
          <option value="PENDING">Pending</option>
          <option value="FAILED">Failed</option>
          <option value="BLOCKED">Blocked</option>
          <option value="ON_HOLD">On Hold</option>
          <option value="REJECTED">Rejected</option>
        </select>

        <input
          type="text"
          placeholder="Filter by coin (e.g. USDT)"
          value={txCoin}
          onChange={(e) => { setTxCoin(e.target.value); setTxPage(1); }}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, minWidth: 170 }}
        />

        <DateRangePicker
          onApply={(_, picker) => {
            setTxStartDate(picker.startDate.format("YYYY-MM-DD"));
            setTxEndDate(picker.endDate.format("YYYY-MM-DD"));
            setTxPage(1);
          }}
          onCancel={() => { setTxStartDate(null); setTxEndDate(null); }}
        >
          <input
            type="text"
            placeholder="Date range"
            readOnly
            style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, cursor: "pointer", minWidth: 180 }}
          />
        </DateRangePicker>

        {txTotal > 0 && <span style={{ fontSize: 13, color: "#555" }}>{txTotal} result{txTotal !== 1 ? "s" : ""}</span>}
      </div>

      {txLoading ? (
        <div style={{ textAlign: "center", padding: 40 }}><Spin size="large" /></div>
      ) : (
        <Table
          pagination={false}
          size="small"
          rowKey={(r) => String(r?._id ?? r?.transactionId ?? Math.random())}
          dataSource={txList}
          columns={[
            { title: "Date", key: "date", render: (_, r) => fmtDate(r?.createdAt) },
            { title: "Coin", key: "coin", render: (_, r) => r?.tokenName ?? r?.coinSymbol ?? r?.coinDetails?.symbol ?? "-" },
            { title: "Amount", key: "amount", render: (_, r) => r?.amount ?? "-" },
            { title: "Type", key: "type", render: (_, r) => r?.type ?? "-" },
            {
              title: "Status", key: "status",
              render: (_, r) => {
                const s = r?.displayStatus ?? r?.orderStatus ?? r?.status ?? "-";
                return <span style={txStatusColor(s)}>{s}</span>;
              },
            },
            { title: "Chain", key: "chain", render: (_, r) => r?.chain ?? "-" },
            { title: "Tx Hash", key: "txHash", render: (_, r) => <CopyableHash value={r?.txHash} sliceLen={12} /> },
            { title: "From", key: "from", render: (_, r) => <CopyableHash value={r?.fromAddress} sliceLen={10} /> },
            { title: "To", key: "to", render: (_, r) => <CopyableHash value={r?.toAddress} sliceLen={10} /> },
          ]}
        />
      )}
      {txTotal > 0 && (
        <CustomPagination
          key={txPaginationKey}
          totalTabs={txTotal}
          tabsPerPage={10}
          handleChange={(p) => setTxPage(p)}
          className={txLoading ? "display-hide" : "display-flex"}
        />
      )}
    </div>
  );

  const renderDepWitTab = ({
    type,
    list,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    status,
    setStatus,
    search,
    setSearch,
    start,
    setStart,
    end,
    setEnd,
    loading,
    isWithdraw,
  }) => (
    <div style={{ padding: "16px 0" }}>
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: 16,
        }}
      >
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          style={{
            padding: "6px 10px",
            borderRadius: 4,
            border: "1px solid #ced4da",
            fontSize: 13,
          }}
        >
          <option value="">All Status</option>
          <option value="PENDING">Pending</option>
          <option value="ACCEPT">Approved</option>
          <option value="REJECT">Rejected</option>
        </select>
        <input
          type="text"
          placeholder={
            isWithdraw
              ? "Search address, tx hash, coin"
              : "Search tx hash, coin"
          }
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            padding: "6px 10px",
            borderRadius: 4,
            border: "1px solid #ced4da",
            fontSize: 13,
            minWidth: 220,
          }}
        />
        <DateRangePicker
          onApply={(_, picker) => {
            setStart(picker.startDate.format("YYYY-MM-DD"));
            setEnd(picker.endDate.format("YYYY-MM-DD"));
          }}
          onCancel={() => {
            setStart(null);
            setEnd(null);
          }}
        >
          <input
            type="text"
            placeholder="Date range"
            value={start && end ? `${start} → ${end}` : ""}
            readOnly
            style={{
              padding: "6px 10px",
              borderRadius: 4,
              border: "1px solid #ced4da",
              fontSize: 13,
              cursor: "pointer",
              minWidth: 200,
            }}
          />
        </DateRangePicker>
        <select
          value={pageSize}
          onChange={(e) => setPageSize(parseInt(e.target.value, 10))}
          style={{
            padding: "6px 10px",
            borderRadius: 4,
            border: "1px solid #ced4da",
            fontSize: 13,
          }}
        >
          {[10, 25, 50, 100].map((n) => (
            <option key={n} value={n}>
              {n}/page
            </option>
          ))}
        </select>
        {(status || search || start || end) && (
          <button
            type="button"
            className="btn btn-sm bg-light"
            onClick={() => {
              setStatus("");
              setSearch("");
              setStart(null);
              setEnd(null);
            }}
          >
            Clear
          </button>
        )}
        {total > 0 && (
          <span style={{ fontSize: 13, color: "#555" }}>
            {total} {type.toLowerCase()}
            {total !== 1 ? "s" : ""}
          </span>
        )}
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : (
        <Table
          pagination={false}
          size="small"
          rowKey={(r) => r?._id}
          dataSource={list}
          columns={[
            {
              title: "Date",
              key: "date",
              render: (_, r) => fmtDate(r?.createdAt),
            },
            {
              title: "Coin",
              key: "coin",
              render: (_, r) => r?.coin?.symbol || "-",
            },
            {
              title: "Amount",
              key: "amount",
              render: (_, r) =>
                r?.amount != null
                  ? `${r?.amount?.toFixed(2) || 0} ${r?.coin?.symbol || ""}`.trim()
                  : "-",
            },
            {
              title: "Final Amount",
              key: "amountAfterDeduction",
              render: (_, r) =>
                r?.amountAfterDeduction != null
                  ? `${r?.amountAfterDeduction?.toFixed(2) || 0} ${r?.coin?.symbol || ""}`.trim()
                  : "-",
            },
            ...(!isWithdraw
              ? [
                  {
                    title: "UTR No.",
                    key: "utrNumber",
                    render: (_, r) => r?.utrNumber || "-",
                  },
                ]
              : []),
            ...(isWithdraw
              ? [
                  {
                    title: "Destination",
                    key: "destinationAddress",
                    render: (_, r) =>
                      r?.destinationAddress ? (
                        <span
                          title={r.destinationAddress}
                          style={{ fontFamily: "monospace", fontSize: 11 }}
                        >
                          {r.destinationAddress.slice(0, 12)}…
                        </span>
                      ) : (
                        "-"
                      ),
                  },
                  {
                    title: "Network",
                    key: "network",
                    render: (_, r) => r?.network || "-",
                  },
                  {
                    title: "Tx Hash",
                    key: "txHash",
                    render: (_, r) =>
                      r?.txHash ? (
                        <span
                          title={r.txHash}
                          style={{ fontFamily: "monospace", fontSize: 11 }}
                        >
                          {r.txHash.slice(0, 12)}…
                        </span>
                      ) : (
                        "-"
                      ),
                  },
                ]
              : []),
            {
              title: "Status",
              key: "status",
              render: (_, r) => (
                <span
                  className={`badge bg-${
                    r.status === "ACCEPT"
                      ? "success"
                      : r.status === "REJECT"
                        ? "danger"
                        : "warning"
                  }`}
                >
                  {r.status}
                </span>
              ),
            },
            {
              title: "Reject Reason",
              key: "rejectReason",
              render: (_, r) =>
                r?.status === "REJECT" && r?.rejectReason
                  ? r.rejectReason
                  : "-",
            },
            {
              title: "Actioned By",
              key: "actionedBy",
              render: (_, r) =>
                r?.status === "ACCEPT"
                  ? r?.acceptedByEmail || "-"
                  : r?.status === "REJECT"
                    ? r?.rejectedByEmail || "-"
                    : "-",
            },
          ]}
        />
      )}
      {total > pageSize && (
        <CustomPagination
          key={`${type}-${pageSize}-${status}`}
          totalTabs={total}
          tabsPerPage={pageSize}
          handleChange={(p) => setPage(p)}
          className={loading ? "display-hide" : "display-flex"}
        />
      )}
    </div>
  );

  const DepositsTab = () =>
    renderDepWitTab({
      type: "deposit",
      list: depList,
      total: depTotal,
      page: depPage,
      pageSize: depPageSize,
      setPage: setDepPage,
      setPageSize: setDepPageSize,
      status: depStatus,
      setStatus: setDepStatus,
      search: depSearch,
      setSearch: setDepSearch,
      start: depStart,
      setStart: setDepStart,
      end: depEnd,
      setEnd: setDepEnd,
      loading: depLoading,
      isWithdraw: false,
    });

  const WithdrawalsTab = () =>
    renderDepWitTab({
      type: "withdrawal",
      list: witList,
      total: witTotal,
      page: witPage,
      pageSize: witPageSize,
      setPage: setWitPage,
      setPageSize: setWitPageSize,
      status: witStatus,
      setStatus: setWitStatus,
      search: witSearch,
      setSearch: setWitSearch,
      start: witStart,
      setStart: setWitStart,
      end: witEnd,
      setEnd: setWitEnd,
      loading: witLoading,
      isWithdraw: true,
    });

  const OrdersTab = () => (
    <div style={{ padding: "16px 0" }}>
      {orderTotal > 0 && <div style={{ fontSize: 13, color: "#555", marginBottom: 12 }}>{orderTotal} order{orderTotal !== 1 ? "s" : ""}</div>}
      {orderLoading ? (
        <div style={{ textAlign: "center", padding: 40 }}><Spin size="large" /></div>
      ) : (
        <Table
          pagination={false}
          size="small"
          rowKey={(r) => r?._id ?? r?.orderId}
          dataSource={orderList}
          columns={[
            { title: "Date", key: "date", render: (_, r) => fmtDate(r?.createdAt) },
            { title: "Pair", key: "pair", render: (_, r) => { const from = r?.fromCoin?.symbol; const to = r?.toCoin?.symbol; return from && to ? `${from}/${to}` : "-"; } },
            { title: "Side", key: "side", render: (_, r) => r?.orderType ?? "-" },
            { title: "Order Type", key: "type", render: (_, r) => r?.type ?? "-" },
            { title: "Amount", key: "amount", render: (_, r) => r?.amount != null ? `${r.amount} ${r?.toCoin?.symbol ?? ""}`.trim() : "-" },
            { title: "Price", key: "price", render: (_, r) => r?.price != null ? `${r.price} ${r?.toCoin?.symbol ?? ""}`.trim() : "-" },
            { title: "Quantity", key: "qty", render: (_, r) => r?.quantity != null ? `${r.quantity} ${r?.fromCoin?.symbol ?? ""}`.trim() : "-" },
            { title: "Status", key: "status", render: (_, r) => r?.orderStatus ?? "-" },
            {
              title: "Action",
              key: "action",
              render: (_, r) => r?._id ? (
                <button
                  className="btn btn-sm bg-primary-light"
                  onClick={() => history.push(`/admin/order-detail/${r._id}`)}
                >
                  View Details
                </button>
              ) : null,
            },
          ]}
        />
      )}
      {orderTotal > 10 && (
        <CustomPagination
          totalTabs={orderTotal}
          tabsPerPage={10}
          handleChange={(p) => setOrderPage(p)}
          className={orderLoading ? "display-hide" : "display-flex"}
        />
      )}
    </div>
  );

  const LogsTab = () => (
    <div style={{ padding: "16px 0" }}>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 14 }}>
        <select value={logType} onChange={(e) => setLogType(e.target.value)} style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13 }}>
          <option value="">All Types</option>
          {["audit", "api", "error", "admin", "event"].map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
        <select value={logAction} onChange={(e) => setLogAction(e.target.value)} style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, minWidth: 160 }}>
          <option value="">All Actions</option>
          {logActions.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        <input
          type="text"
          placeholder="Search logs…"
          value={logSearch}
          onChange={(e) => setLogSearch(e.target.value)}
          style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, minWidth: 200 }}
        />
        <DateRangePicker
          startDate={moment(logFrom)}
          endDate={moment(logTo)}
          onApply={(_, picker) => {
            setLogFrom(picker.startDate.toISOString());
            setLogTo(picker.endDate.toISOString());
          }}
        >
          <input
            type="text"
            placeholder="Date range"
            readOnly
            style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ced4da", fontSize: 13, cursor: "pointer", minWidth: 180 }}
          />
        </DateRangePicker>
        {logCount > 0 && <span style={{ fontSize: 13, color: "#555" }}>{logCount} log{logCount !== 1 ? "s" : ""}</span>}
      </div>

      {logLoading ? (
        <div style={{ textAlign: "center", padding: 40 }}><Spin size="large" /></div>
      ) : (
        <Table
          size="small"
          rowKey={(r, i) => r?.requestId ?? i}
          dataSource={logList}
          expandable={{
            expandedRowKeys: expandedLog ? [expandedLog] : [],
            onExpand: (expanded, record) => {
              const key = record?.requestId ?? logList.indexOf(record);
              setExpandedLog(expanded ? key : null);
            },
            expandedRowRender: (record) => (
              <pre style={{ fontSize: 11, maxHeight: 300, overflowY: "auto", background: "#f5f5f5", padding: 10, borderRadius: 4 }}>
                {JSON.stringify(record, null, 2)}
              </pre>
            ),
          }}
          pagination={{ pageSize: 50, showSizeChanger: false, showTotal: (t) => `${t} logs` }}
          columns={[
            { title: "Timestamp", key: "ts", width: 160, render: (_, r) => r?.timestamp ? moment(r.timestamp).utcOffset("+05:30").format("YYYY-MM-DD hh:mm:ss A") : "-" },
            { title: "Service", key: "service", width: 80, render: (_, r) => r?.service ?? "-" },
            { title: "Type", key: "type", width: 70, render: (_, r) => r?.type ?? "-" },
            { title: "Action", key: "action", render: (_, r) => r?.action ?? "-" },
            { title: "Method", key: "method", width: 70, render: (_, r) => r?.method ?? "-" },
            {
              title: "Status", key: "status", width: 70,
              render: (_, r) => (
                <span style={{ color: statusColor(r?.statusCode), fontWeight: 600 }}>
                  {r?.statusCode ?? "-"}
                </span>
              ),
            },
            { title: "Path", key: "path", render: (_, r) => <span style={{ fontFamily: "monospace", fontSize: 11 }}>{r?.path ?? "-"}</span> },
            { title: "IP", key: "ip", width: 120, render: (_, r) => r?.ip ?? "-" },
            { title: "Duration", key: "duration", width: 90, render: (_, r) => r?.duration != null ? `${r.duration}ms` : "-" },
          ]}
        />
      )}
    </div>
  );

  const KycSubEditCard = ({ label, value, onChange, disabled }) => {
    const sub = value ?? DEFAULT_KYC_SUB;
    const cp  = sub.coolingPeriod ?? { value: 24, unit: "HOURS" };
    return (
      <div style={{ border: "1px solid #e8e8e8", borderRadius: 8, padding: 16, background: "#fff" }}>
        <div style={{ fontWeight: 600, marginBottom: 12 }}>{label}</div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              cursor: disabled ? "not-allowed" : "pointer",
              background: sub.enabled ? "#52c41a" : "#d9d9d9",
              borderRadius: 12,
              width: 40,
              height: 22,
              padding: "0 3px",
              transition: "background 0.2s",
            }}
            onClick={() => !disabled && onChange({ ...sub, enabled: !sub.enabled })}
          >
            <span style={{ display: "inline-block", width: 16, height: 16, background: "#fff", borderRadius: "50%", transition: "transform 0.2s", transform: sub.enabled ? "translateX(18px)" : "translateX(0)" }} />
          </span>
          <span style={{ fontSize: 13 }}>{sub.enabled ? "Enabled" : "Disabled"}</span>
        </div>
        <div style={{ fontSize: 12, opacity: 0.6, marginBottom: 6 }}>Cooling Period</div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <input
            type="number"
            min={0}
            value={cp.value ?? 0}
            onChange={(e) => onChange({ ...sub, coolingPeriod: { ...cp, value: parseInt(e.target.value, 10) || 0 } })}
            disabled={disabled}
            style={{ width: 80, padding: "4px 8px", borderRadius: 4, border: "1px solid #d9d9d9", fontSize: 13 }}
          />
          <select
            value={cp.unit ?? "HOURS"}
            onChange={(e) => onChange({ ...sub, coolingPeriod: { ...cp, unit: e.target.value } })}
            disabled={disabled}
            style={{ padding: "4px 8px", borderRadius: 4, border: "1px solid #d9d9d9", fontSize: 13 }}
          >
            <option value="HOURS">Hours</option>
            <option value="DAYS">Days</option>
          </select>
          {value !== null && (
            <button
              onClick={() => !disabled && onChange(null)}
              disabled={disabled}
              style={{ fontSize: 11, color: "#999", background: "none", border: "none", cursor: "pointer", padding: 0, marginLeft: 4 }}
            >
              Clear override
            </button>
          )}
        </div>
        {value === null && (
          <div style={{ marginTop: 8 }}>
            <button
              onClick={() => !disabled && onChange({ ...DEFAULT_KYC_SUB })}
              disabled={disabled}
              style={{ fontSize: 12, color: "#1677ff", background: "none", border: "none", cursor: "pointer", padding: 0 }}
            >
              + Set override
            </button>
          </div>
        )}
      </div>
    );
  };

  const KycConfigTab = () => {
    const saveKycConfig = async () => {
      setKycConfigSaving(true);
      try {
        const payload = {};
        for (const { key } of TX_SUB_LABELS) {
          payload[key] = kycUserForm?.[key] ?? null;
        }
        await updateUserKycConfig(id, payload);
        toast.success("User transaction config saved", { toastId: "kyc-config-user-save" });
        await fetchKycConfig();
      } catch (e) {
        toast.error(e?.data?.message || "Failed to save config", { toastId: "kyc-config-user-save" });
      } finally {
        setKycConfigSaving(false);
      }
    };

    return (
      <div style={{ padding: "16px 0" }}>
        {kycConfigLoading ? (
          <div style={{ textAlign: "center", padding: 40 }}><Spin /></div>
        ) : (
          <div style={{ display: "flex", gap: 24, flexWrap: "wrap", alignItems: "flex-start" }}>
            {/* Left: editable user overrides */}
            <div style={{ flex: 1, minWidth: 320 }}>
              <div style={{ fontWeight: 600, marginBottom: 12, fontSize: 14 }}>User Override</div>
              <p style={{ fontSize: 12, opacity: 0.6, marginBottom: 16 }}>
                Leave as "Global" (no override) to inherit global defaults. Set an override to apply user-specific values.
              </p>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, marginBottom: 16 }}>
                {TX_SUB_LABELS.map(({ key, label }) => (
                  <KycSubEditCard
                    key={key}
                    label={label}
                    value={kycUserForm?.[key] ?? null}
                    onChange={(val) => setKycUserForm((prev) => ({ ...(prev ?? {}), [key]: val }))}
                    disabled={kycConfigSaving}
                  />
                ))}
              </div>
              <button
                onClick={saveKycConfig}
                disabled={kycConfigSaving}
                style={{
                  background: "#1677ff",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "8px 20px",
                  fontSize: 13,
                  cursor: kycConfigSaving ? "not-allowed" : "pointer",
                  opacity: kycConfigSaving ? 0.7 : 1,
                }}
              >
                {kycConfigSaving ? "Saving…" : "Save Override"}
              </button>
            </div>

            {/* Right: read-only resolved (effective) config */}
            <div style={{ flex: 1, minWidth: 280 }}>
              <div style={{ fontWeight: 600, marginBottom: 12, fontSize: 14 }}>Effective Config (Resolved)</div>
              <p style={{ fontSize: 12, opacity: 0.6, marginBottom: 16 }}>
                What actually applies to this user — user override if set, otherwise global default.
              </p>
              {kycResolved ? (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
                  {TX_SUB_LABELS.map(({ key, label }) => {
                    const r = kycResolved[key];
                    if (!r) return null;
                    const isUser = r.source === "user";
                    return (
                      <div key={key} style={{ border: "1px solid #e8e8e8", borderRadius: 8, padding: 14, background: "#fafafa" }}>
                        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8 }}>{label}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                          <span style={{ fontSize: 12, fontWeight: 500, color: r.enabled ? "#52c41a" : "#ff4d4f" }}>
                            {r.enabled ? "Enabled" : "Disabled"}
                          </span>
                        </div>
                        <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 8 }}>
                          Cooling: {r.coolingPeriod?.value ?? 0} {r.coolingPeriod?.unit ?? "HOURS"}
                        </div>
                        <span style={{
                          fontSize: 11,
                          padding: "2px 8px",
                          borderRadius: 10,
                          background: isUser ? "#e6f4ff" : "#f5f5f5",
                          color: isUser ? "#1677ff" : "#888",
                          fontWeight: 500,
                        }}>
                          {isUser ? "User override" : "Global default"}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div style={{ opacity: 0.5, fontSize: 13 }}>No resolved config available.</div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  // ─── render ───────────────────────────────────────────────────────────────

  const qaConfig = {
    freeze: {
      title: data?.isFrozen ? "Unfreeze Account" : "Freeze Account",
      body: data?.isFrozen
        ? "Are you sure you want to unfreeze this account? The user will be able to trade and withdraw again."
        : "Are you sure you want to freeze this account? The user will be unable to trade or withdraw.",
      confirmLabel: data?.isFrozen ? "Unfreeze" : "Freeze",
      btnColor: data?.isFrozen ? "#2e7d32" : "#e65100",
    },
    restrict: {
      title: data?.withdrawRestricted ? "Lift Withdrawal Restriction" : "Restrict Withdrawals",
      body: data?.withdrawRestricted
        ? "Are you sure you want to lift the withdrawal restriction on this account?"
        : "Are you sure you want to restrict withdrawals for this account? The user will be unable to withdraw funds.",
      confirmLabel: data?.withdrawRestricted ? "Lift Restriction" : "Restrict",
      btnColor: data?.withdrawRestricted ? "#2e7d32" : "#b71c1c",
    },
    delete: {
      title: "Delete Account",
      body: "Are you sure you want to delete this account? The user will be locked out. This can be reversed.",
      confirmLabel: "Delete",
      btnColor: "#b71c1c",
    },
    reactivate: {
      title: "Reactivate Account",
      body: "Are you sure you want to reactivate this account?",
      confirmLabel: "Reactivate",
      btnColor: "#2e7d32",
    },
    deactivate: {
      title: "Deactivate Account",
      body: "Once deactivated, the user will not be able to log in. They will need to raise a support ticket to reactivate the account.",
      confirmLabel: "Deactivate",
      btnColor: "#e65100",
    },
    activate: {
      title: "Activate Account",
      body: "Are you sure you want to activate this account? The user will be able to log in again.",
      confirmLabel: "Activate",
      btnColor: "#2e7d32",
    },
  };

  // Horizontal action pill — Stripe/Linear style. Icon left, label right,
  // colored dot indicates "applied" state. Wraps gracefully on narrow widths.
  const ActionPill = ({
    Icon,
    label,
    onClick,
    tone = "neutral", // 'neutral' | 'warning' | 'danger' | 'success'
    active = false,
    disabled = false,
    helpTitle = "",
  }) => {
    const tones = {
      neutral: { iconBg: "#F4F6F7", iconFg: "#3B454F" },
      warning: { iconBg: "#FFF6DD", iconFg: "#A06900" },
      danger:  { iconBg: "#FEEAEE", iconFg: "#A8001F" },
      success: { iconBg: "#E6FAF0", iconFg: "#0A7A3B" },
    };
    const t = tones[tone] || tones.neutral;
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        title={helpTitle}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "6px 12px 6px 6px",
          border: "1px solid #E2E6EA",
          borderRadius: 999,
          background: "#fff",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.55 : 1,
          transition: "all 0.15s ease",
          height: 34,
          whiteSpace: "nowrap",
        }}
        onMouseEnter={(e) => {
          if (!disabled) {
            e.currentTarget.style.background = "#FAFBFC";
            e.currentTarget.style.borderColor = "#CED4DA";
            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)";
          }
        }}
        onMouseLeave={(e) => {
          if (!disabled) {
            e.currentTarget.style.background = "#fff";
            e.currentTarget.style.borderColor = "#E2E6EA";
            e.currentTarget.style.boxShadow = "none";
          }
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 22,
            height: 22,
            borderRadius: "50%",
            background: t.iconBg,
            color: t.iconFg,
            flexShrink: 0,
          }}
        >
          <Icon size={13} />
        </span>
        <span
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: "#20262C",
            lineHeight: 1,
          }}
        >
          {label}
        </span>
        {active && (
          <span
            style={{
              display: "inline-block",
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#0ECB81",
              marginLeft: 2,
              boxShadow: "0 0 0 2px #E6FAF0",
            }}
          />
        )}
      </button>
    );
  };

  const QuickActionsPanel = () => (
    <div
      style={{
        background: "#fff",
        border: "1px solid #EDEFF2",
        borderRadius: 12,
        padding: "14px 16px",
        boxShadow: "0 1px 3px rgba(20, 30, 50, 0.04)",
      }}
    >
      {/* Card header (compact, left-aligned) */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginBottom: 12,
        }}
      >
        <FiZap size={14} color="#1A3FBD" />
        <span
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: "#20262C",
            textTransform: "uppercase",
            letterSpacing: 0.6,
          }}
        >
          Quick Actions
        </span>
        <span
          style={{
            flex: 1,
            height: 1,
            background: "#F1F3F5",
            marginLeft: 8,
          }}
        />
      </div>

      {/* Action pills — flow left-to-right, wrap as needed */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          justifyContent: "flex-start",
        }}
      >
        <ActionPill
          Icon={data?.isBlock ? FiCheckCircle : FiSlash}
          label={data?.isBlock ? "Unblock User" : "Block User"}
          tone={data?.isBlock ? "success" : "danger"}
          active={data?.isBlock}
          onClick={() => openBlockModal(!data?.isBlock)}
        />
        <ActionPill
          Icon={data?.isDeactivated ? FiUserCheck : FiUserX}
          label={data?.isDeactivated ? "Activate Account" : "Deactivate Account"}
          tone={data?.isDeactivated ? "success" : "warning"}
          active={data?.isDeactivated}
          helpTitle="Once deactivated, the user cannot log in. They must raise a support ticket to be reactivated."
          onClick={() => setQaModal(data?.isDeactivated ? "activate" : "deactivate")}
        />
        <ActionPill
          Icon={FiPauseCircle}
          label={data?.isFrozen ? "Unfreeze" : "Freeze Account"}
          tone="warning"
          active={data?.isFrozen}
          onClick={() => setQaModal("freeze")}
        />
        <ActionPill
          Icon={FiXOctagon}
          label={
            data?.withdrawRestricted
              ? "Lift Withdrawal Restriction"
              : "Restrict Withdrawals"
          }
          tone="danger"
          active={data?.withdrawRestricted}
          onClick={() => setQaModal("restrict")}
        />
        <ActionPill
          Icon={FiRefreshCw}
          label={data?.kycRedoRequired ? "KYC Redo Pending" : "Force KYC Re-do"}
          tone="warning"
          active={data?.kycRedoRequired}
          disabled={data?.kycRedoRequired}
          helpTitle={
            data?.kycRedoRequired
              ? "User already required to redo KYC"
              : "Send the user back through KYC verification"
          }
          onClick={() => {
            setKycRedoReason("");
            setKycRedoOpen(true);
          }}
        />

        {/* Visual divider before destructive */}
        <span
          style={{
            width: 1,
            height: 26,
            background: "#E2E6EA",
            alignSelf: "center",
            margin: "0 4px",
          }}
        />

        {data?.isDeleted ? (
          <ActionPill
            Icon={FiRotateCcw}
            label="Reactivate Account"
            tone="success"
            onClick={() => setQaModal("reactivate")}
          />
        ) : (
          <ActionPill
            Icon={FiTrash2}
            label="Delete Account"
            tone="danger"
            onClick={() => setQaModal("delete")}
          />
        )}
      </div>
    </div>
  );

  return (
    <>
      <SidebarNav />

      {/* Block / Unblock Reason Modal */}
      {blockOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 28,
              maxWidth: 440,
              width: "90%",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            }}
          >
            <h4 style={{ marginBottom: 8, fontSize: 18, fontWeight: 700 }}>
              {blockAction ? "Block User" : "Unblock User"}
            </h4>
            <p style={{ marginBottom: 16, color: "#555", lineHeight: 1.5 }}>
              {blockAction
                ? "Blocking will prevent the user from trading, depositing, and withdrawing until lifted. Please provide a reason."
                : "Unblocking will restore the user's access to the platform."}
            </p>
            <label
              style={{
                display: "block",
                fontSize: 13,
                fontWeight: 600,
                color: "#20262C",
                marginBottom: 6,
              }}
            >
              Reason{blockAction ? " *" : " (optional)"}
            </label>
            <textarea
              value={blockReason}
              onChange={(e) => {
                setBlockReason(e.target.value);
                setBlockReasonError(false);
              }}
              placeholder={
                blockAction
                  ? "Why is this user being blocked?"
                  : "Why is this user being unblocked?"
              }
              rows={3}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: `1px solid ${
                  blockReasonError ? "#F6465D" : "#E2E2E2"
                }`,
                borderRadius: 6,
                fontSize: 13,
                fontFamily: "inherit",
                outline: "none",
                resize: "vertical",
              }}
            />
            {blockReasonError && (
              <div
                style={{ color: "#F6465D", fontSize: 12, marginTop: 6 }}
              >
                Reason is required to block a user
              </div>
            )}
            <div
              style={{
                display: "flex",
                gap: 10,
                justifyContent: "flex-end",
                marginTop: 18,
              }}
            >
              <button
                onClick={() => {
                  setBlockOpen(false);
                  setBlockReason("");
                  setBlockReasonError(false);
                }}
                disabled={blockLoading}
                style={{
                  padding: "8px 18px",
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  background: "#fff",
                  cursor: "pointer",
                  fontSize: 13,
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleBlockConfirm}
                disabled={blockLoading}
                style={{
                  padding: "8px 18px",
                  border: "none",
                  borderRadius: 6,
                  background: blockAction ? "#A8001F" : "#0A7A3B",
                  color: "#fff",
                  cursor: blockLoading ? "not-allowed" : "pointer",
                  fontSize: 13,
                  fontWeight: 600,
                  opacity: blockLoading ? 0.7 : 1,
                }}
              >
                {blockLoading
                  ? "Processing…"
                  : blockAction
                    ? "Block User"
                    : "Unblock User"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Quick Action Confirmation Modal */}
      {qaModal && qaConfig[qaModal] && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 10, padding: 28, maxWidth: 420, width: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
            <h4 style={{ marginBottom: 12, fontSize: 18, fontWeight: 700 }}>{qaConfig[qaModal].title}</h4>
            <p style={{ marginBottom: 24, color: "#555", lineHeight: 1.5 }}>{qaConfig[qaModal].body}</p>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button onClick={() => setQaModal(null)} disabled={qaLoading} style={{ padding: "8px 18px", border: "1px solid #ccc", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 13 }}>
                Cancel
              </button>
              <button
                onClick={handleQuickAction}
                disabled={qaLoading}
                style={{ padding: "8px 18px", border: "none", borderRadius: 6, background: qaConfig[qaModal].btnColor, color: "#fff", cursor: qaLoading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 600, opacity: qaLoading ? 0.7 : 1 }}
              >
                {qaLoading ? "Processing…" : qaConfig[qaModal].confirmLabel}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bank Approve Confirmation Modal */}
      {bankApproveOpen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 10, padding: 28, maxWidth: 440, width: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
            <h4 style={{ marginBottom: 12, fontSize: 18, fontWeight: 700 }}>Approve Bank Account</h4>
            <p style={{ marginBottom: 12, color: "#555", lineHeight: 1.5 }}>
              You are about to approve this user's bank account despite the name mismatch with their KYC.
              The user will be able to use this bank for fiat withdrawals after approval.
            </p>
            <div style={{ background: "#f8f9fa", padding: 12, borderRadius: 6, marginBottom: 16, fontSize: 13 }}>
              <div><strong>Bank:</strong> {data?.bankName || "-"}</div>
              <div><strong>A/C:</strong> {data?.bankAccountNumber || "-"}</div>
              <div>
                <strong>Name on Bank:</strong>{" "}
                {data?.bankDetails?.beneficiary_name_with_bank || "-"}
              </div>
              <div>
                <strong>KYC Legal Name:</strong>{" "}
                {data?.kyc?.legalName ||
                  [data?.kyc?.firstName, data?.kyc?.middleName, data?.kyc?.lastName]
                    .filter(Boolean)
                    .join(" ") ||
                  [data?.firstName, data?.lastName].filter(Boolean).join(" ") ||
                  "-"}
              </div>
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button onClick={() => setBankApproveOpen(false)} disabled={bankActionLoading} style={{ padding: "8px 18px", border: "1px solid #ccc", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 13 }}>
                Cancel
              </button>
              <button
                onClick={handleApproveBank}
                disabled={bankActionLoading}
                style={{ padding: "8px 18px", border: "none", borderRadius: 6, background: "#0a7a3b", color: "#fff", cursor: bankActionLoading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 600, opacity: bankActionLoading ? 0.7 : 1 }}
              >
                {bankActionLoading ? "Approving…" : "Approve Bank"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* KYC Approve / Reject Modal — reason + email OTP */}
      {kycDecision && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 10, padding: 28, maxWidth: 480, width: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
            <h4 style={{ marginBottom: 12, fontSize: 18, fontWeight: 700, color: kycDecision === "APPROVED" ? "#0a7a3b" : "#a8001f" }}>
              {kycDecision === "APPROVED" ? "Approve KYC" : "Reject KYC"}
            </h4>
            <p style={{ marginBottom: 12, color: "#555", lineHeight: 1.5 }}>
              {kycDecision === "APPROVED"
                ? "The user's KYC will be marked approved and they will be notified."
                : "The user's KYC will be marked rejected and they will receive the reason by email."}{" "}
              An OTP is emailed to the admin inbox to confirm this action. You can change this decision later.
            </p>
            <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>
              Reason {kycReasonRequired(kycDecision) ? <span style={{ color: "#a8001f" }}>*</span> : <span style={{ color: "#888", fontWeight: 400 }}>(optional)</span>}
            </label>
            <textarea
              rows={3}
              maxLength={500}
              value={kycDecisionReason}
              disabled={kycOtpSent}
              onChange={(e) => {
                setKycDecisionReason(e.target.value);
                setKycDecisionReasonError(false);
              }}
              placeholder={kycDecision === "REJECTED" ? "e.g. Selfie does not match the ID document." : "e.g. Documents verified manually."}
              style={{
                width: "100%",
                padding: 8,
                borderRadius: 6,
                fontSize: 13,
                border: kycDecisionReasonError ? "1px solid #a8001f" : "1px solid #ccc",
                outline: "none",
                resize: "vertical",
                marginBottom: 12,
              }}
            />
            {kycDecisionReasonError && (
              <div style={{ color: "#a8001f", fontSize: 12, marginTop: -8, marginBottom: 10 }}>Reason is required.</div>
            )}

            {kycOtpSent && (
              <div style={{ marginBottom: 12 }}>
                <div style={{ background: "#eef6ff", border: "1px solid #b7d2ff", borderRadius: 6, padding: "8px 10px", fontSize: 12, color: "#27456b", marginBottom: 10 }}>
                  We sent an OTP{kycOtpSentTo.length ? ` to ${kycOtpSentTo.join(", ")}` : " to the admin email"}. Please verify it below. It is valid for 5 minutes.
                </div>
                <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Enter OTP</label>
                <input
                  type="text"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  maxLength={6}
                  autoFocus
                  value={kycOtp}
                  onChange={(e) => {
                    setKycOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
                    setKycOtpError("");
                  }}
                  placeholder="6-digit OTP"
                  style={{
                    width: "100%",
                    padding: 8,
                    borderRadius: 6,
                    fontSize: 16,
                    letterSpacing: 6,
                    border: kycOtpError ? "1px solid #a8001f" : "1px solid #ccc",
                    outline: "none",
                  }}
                />
                {kycOtpError && <div style={{ color: "#a8001f", fontSize: 12, marginTop: 4 }}>{kycOtpError}</div>}
                <button
                  onClick={() => handleSendKycOtp(true)}
                  disabled={kycOtpSending || kycDecisionLoading}
                  style={{ marginTop: 6, background: "none", border: "none", padding: 0, color: "#0073ff", cursor: "pointer", fontSize: 12 }}
                >
                  {kycOtpSending ? "Sending…" : "Resend OTP"}
                </button>
              </div>
            )}

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                onClick={closeKycDecision}
                disabled={kycDecisionLoading}
                style={{ padding: "8px 18px", border: "1px solid #ccc", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 13 }}
              >
                Cancel
              </button>
              {!kycOtpSent ? (
                <button
                  onClick={() => handleSendKycOtp(false)}
                  disabled={kycOtpSending}
                  style={{ padding: "8px 18px", border: "none", borderRadius: 6, background: "#0073ff", color: "#fff", cursor: kycOtpSending ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 600, opacity: kycOtpSending ? 0.7 : 1 }}
                >
                  {kycOtpSending ? "Sending OTP…" : "Send OTP"}
                </button>
              ) : (
                <button
                  onClick={handleConfirmKycDecision}
                  disabled={kycDecisionLoading || kycOtp.length !== 6}
                  style={{
                    padding: "8px 18px",
                    border: "none",
                    borderRadius: 6,
                    background: kycDecision === "APPROVED" ? "#0a7a3b" : "#a8001f",
                    color: "#fff",
                    cursor: kycDecisionLoading || kycOtp.length !== 6 ? "not-allowed" : "pointer",
                    fontSize: 13,
                    fontWeight: 600,
                    opacity: kycDecisionLoading || kycOtp.length !== 6 ? 0.6 : 1,
                  }}
                >
                  {kycDecisionLoading ? "Verifying…" : kycDecision === "APPROVED" ? "Verify & Approve" : "Verify & Reject"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Bank Reject Modal */}
      {bankRejectOpen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 10, padding: 28, maxWidth: 460, width: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
            <h4 style={{ marginBottom: 12, fontSize: 18, fontWeight: 700, color: "#a8001f" }}>Reject Bank Account</h4>
            <p style={{ marginBottom: 12, color: "#555", lineHeight: 1.5 }}>
              The user's current bank details will be cleared and pushed to bank history. The user will receive an email
              with the reason and can submit a new bank account (this rejection does not consume their bank-change limit).
            </p>
            <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>
              Reason <span style={{ color: "#a8001f" }}>*</span>
            </label>
            <textarea
              rows={3}
              value={bankRejectReason}
              onChange={(e) => {
                setBankRejectReason(e.target.value);
                setBankRejectError(false);
              }}
              placeholder="e.g. Name on bank does not match KYC, or document quality issue."
              style={{
                width: "100%",
                padding: 8,
                borderRadius: 6,
                fontSize: 13,
                border: bankRejectError ? "1px solid #a8001f" : "1px solid #ccc",
                outline: "none",
                resize: "vertical",
                marginBottom: 16,
              }}
            />
            {bankRejectError && (
              <div style={{ color: "#a8001f", fontSize: 12, marginTop: -10, marginBottom: 10 }}>
                Reason is required.
              </div>
            )}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                onClick={() => {
                  setBankRejectOpen(false);
                  setBankRejectReason("");
                  setBankRejectError(false);
                }}
                disabled={bankActionLoading}
                style={{ padding: "8px 18px", border: "1px solid #ccc", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 13 }}
              >
                Cancel
              </button>
              <button
                onClick={handleRejectBank}
                disabled={bankActionLoading}
                style={{ padding: "8px 18px", border: "none", borderRadius: 6, background: "#a8001f", color: "#fff", cursor: bankActionLoading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 600, opacity: bankActionLoading ? 0.7 : 1 }}
              >
                {bankActionLoading ? "Rejecting…" : "Reject Bank"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Force KYC Re-do Modal */}
      {kycRedoOpen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 10, padding: 28, maxWidth: 460, width: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
            <h4 style={{ marginBottom: 12, fontSize: 18, fontWeight: 700, color: "#e65100" }}>Force KYC Re-do</h4>
            <p style={{ marginBottom: 12, color: "#555", lineHeight: 1.5 }}>
              The user's current KYC will be archived to KycLogs and they will be required to re-verify their identity
              on next login. KYC-gated features (incl. fiat withdrawals) will be unavailable until they complete KYC again.
            </p>
            <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>
              Reason (optional)
            </label>
            <textarea
              rows={3}
              value={kycRedoReason}
              onChange={(e) => setKycRedoReason(e.target.value)}
              placeholder="e.g. Suspected document fraud, scheduled re-KYC, change of identity records."
              style={{
                width: "100%",
                padding: 8,
                borderRadius: 6,
                fontSize: 13,
                border: "1px solid #ccc",
                outline: "none",
                resize: "vertical",
                marginBottom: 16,
              }}
            />
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                onClick={() => {
                  setKycRedoOpen(false);
                  setKycRedoReason("");
                }}
                disabled={kycRedoLoading}
                style={{ padding: "8px 18px", border: "1px solid #ccc", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 13 }}
              >
                Cancel
              </button>
              <button
                onClick={handleTriggerKycRedo}
                disabled={kycRedoLoading}
                style={{ padding: "8px 18px", border: "none", borderRadius: 6, background: "#e65100", color: "#fff", cursor: kycRedoLoading ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 600, opacity: kycRedoLoading ? 0.7 : 1 }}
              >
                {kycRedoLoading ? "Resetting…" : "Force KYC Re-do"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="page-wrapper">
        <div className="content container-fluid">
          <DetailLayout
            breadcrumb={[
              { label: "Dashboard", to: "/admin" },
              { label: "Users", to: "/admin/user" },
              { label: "Profile" },
            ]}
            title="User profile"
            subtitle={data?.firstName ? `${data.firstName} ${data.lastName ?? ""}` : ""}
            actions={!dataLoading && data ? <QuickActionsPanel /> : null}
          >
            {dataLoading ? (
              <div style={{ textAlign: "center", padding: 60 }}>
                <Spin size="large" />
              </div>
            ) : (
              <Tabs
                type="card"
                defaultActiveKey="overview"
                onChange={handleTabChange}
                items={[
                  { key: "overview", label: "Overview", children: <OverviewTab /> },
                  { key: "kyc", label: "KYC & Compliance", children: <KycTab /> },
                  { key: "balances", label: "Balances & Wallets", children: <BalancesTab /> },
                  { key: "transactions", label: "Crypto Transaction History", children: TransactionsTab() },
                  { key: "deposits", label: "Fiat Deposit", children: <DepositsTab /> },
                  { key: "withdrawals", label: "Fiat Withdraw", children: <WithdrawalsTab /> },
                  { key: "orders", label: "Orders / Trades", children: <OrdersTab /> },
                  { key: "walletActivityLog", label: "Wallet Activity Log", children: <UserActivityLogTab userId={id} active={activeTabKey === "walletActivityLog"} /> },
                  { key: "walletAdjustment", label: "Manual Wallet Adjustment", children: <WalletAdjustmentTab userId={id} active={activeTabKey === "walletAdjustment"} /> },
                  { key: "cryptoWithdraw", label: "Deposit & Withdraw Manager", children: <CryptoWithdrawTab userId={id} initialConfig={data?.cryptoWithdraw} /> },
                  { key: "logs", label: "Activity Logs", children: <LogsTab /> },
                  // { key: "kyc-config", label: "KYC Configuration", children: <KycConfigTab /> },
                ]}
              />
            )}
          </DetailLayout>
        </div>
      </div>
    </>
  );
};

export default UserProfileView;
